export const completeDatabaseSchema = {
  abwicklung_hardwarelieferant: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'notes',
        type: 'varchar(250)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'object_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'content_type_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'abwicklung_hardwareliefe_name_content_type_id_obj_8f7208bf_uniq',
        columns: ['name', 'content_type_id', 'object_id'],
        type: 'UNIQUE'
      },
      {
        name: 'abwicklung__content_ee0fce_idx',
        columns: ['content_type_id', 'object_id'],
        type: 'BTREE'
      },
      {
        name: 'abwicklung_hardwarel_created_by_id_2a6152f4_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'abwicklung_hardwarel_lastmodified_by_id_ade5aa33_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'abwicklung_hardwarelieferant_created_at_1879b550',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'abwicklung_hardwarelieferant_lastmodified_at_7c52023c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'abwicklung_hardwarelieferant_name_d7bf1b78',
        columns: ['name'],
        type: 'BTREE'
      },
      {
        name: 'abwicklung_hardwarelieferant_object_id_498a1646',
        columns: ['object_id'],
        type: 'BTREE'
      }
    ]
  },
  actstream_action: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'actor_content_type_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'actor_object_id',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'verb',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'description',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'target_content_type_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'target_object_id',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'action_object_content_type_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'action_object_object_id',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'timestamp',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'public',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'data',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'actstream_action_3df58830',
        columns: ['actor_content_type_id'],
        type: 'BTREE'
      },
      {
        name: 'actstream_action_276d0c93',
        columns: ['target_content_type_id'],
        type: 'BTREE'
      },
      {
        name: 'actstream_action_f6b51263',
        columns: ['action_object_content_type_id'],
        type: 'BTREE'
      },
      {
        name: 'actor_object_id',
        columns: ['actor_object_id'],
        type: 'BTREE'
      },
      {
        name: 'target_object_id',
        columns: ['target_object_id'],
        type: 'BTREE'
      },
      {
        name: 'action_object_object_id',
        columns: ['action_object_object_id'],
        type: 'BTREE'
      },
      {
        name: 'actstream_action_timestamp_IDX',
        columns: ['timestamp'],
        type: 'BTREE'
      }
    ]
  },
  auth_group: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'name',
        type: 'varchar(150)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'name',
        columns: ['name'],
        type: 'UNIQUE'
      }
    ]
  },
  auth_permission: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'name',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'content_type_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'codename',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'content_type_id',
        columns: ['content_type_id', 'codename'],
        type: 'UNIQUE'
      },
      {
        name: 'auth_permission_37ef4eb4',
        columns: ['content_type_id'],
        type: 'BTREE'
      }
    ]
  },
  berechnung_lastprofil: {
    columns: [
      {
        name: 'H0',
        type: 'decimal(16,14)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'H1',
        type: 'decimal(16,14)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'H2',
        type: 'decimal(16,14)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'H3',
        type: 'decimal(16,14)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'G0',
        type: 'decimal(16,14)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'G1',
        type: 'decimal(16,14)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'G3',
        type: 'decimal(16,14)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'G4',
        type: 'decimal(16,14)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'G5',
        type: 'decimal(16,14)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: []
  },
  core_rundung: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'rundungsart',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'rundungsstellen',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'rundungsziffern',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: []
  },
  dienstleister_fachpartner: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_2fa_enforced',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_granted_vlink_next_app_api_access',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'logo',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'notification_last_sent',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'notification_time_limit',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'firma',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'strasse',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'hausnummer',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'plz',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ort',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_geschlecht',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ansprechpartner_titel',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_anrede',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_vorname',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_nachname',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_telefon',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_email',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'hash',
        type: 'varchar(10)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'email_from',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'email_signature',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'project_list_export',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bearbeitung_durch_lieferant',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'create_activity_log_for_doc',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'email_from_name',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_granted_vlink_sales_app_api_access',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'use_wholesaler_feature',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'hash',
        columns: ['hash'],
        type: 'UNIQUE'
      },
      {
        name: 'email_from',
        columns: ['email_from'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_fachpartner_created_at_361839f7',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_fachpartner_lastmodified_at_c3313bce',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_fachpartner_name_e7c1a7ee',
        columns: ['name'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_fachpa_created_by_id_e416344e_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_fachpa_lastmodified_by_id_451faaad_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_systempartner: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_2fa_enforced',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_granted_vlink_next_app_api_access',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'logo',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'notification_last_sent',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'notification_time_limit',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'firma',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'strasse',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'hausnummer',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'plz',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ort',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_geschlecht',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ansprechpartner_titel',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_anrede',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_vorname',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_nachname',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_telefon',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_email',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'hash',
        type: 'varchar(10)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'email_from',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'email_signature',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'project_list_export',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'allow_logistics',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'paket_verfuegbarkeit_plz_last_modified',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'default_frist_angebot',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'default_frist_konstruktion',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'create_activity_log_for_doc',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'email_from_name',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_granted_vlink_sales_app_api_access',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_granted_vlink_buildingkit_access',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'token',
        type: 'varchar(4)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'use_wholesaler_feature',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'hash',
        columns: ['hash'],
        type: 'UNIQUE'
      },
      {
        name: 'email_from',
        columns: ['email_from'],
        type: 'UNIQUE'
      },
      {
        name: 'token',
        columns: ['token'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_systempartner_created_at_adc865a8',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_systempartner_lastmodified_at_29814488',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_systempartner_name_0631a28d',
        columns: ['name'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_systempartner_allow_logistics_ae605bbb',
        columns: ['allow_logistics'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_system_created_by_id_3c1f622d_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_system_lastmodified_by_id_b2d6825d_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_umsetzungspartner: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_2fa_enforced',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_granted_vlink_next_app_api_access',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_granted_vlink_sales_app_api_access',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'firma',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'strasse',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'hausnummer',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'plz',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ort',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_geschlecht',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ansprechpartner_titel',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_anrede',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_vorname',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_nachname',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_telefon',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_email',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'notification_last_sent',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'notification_time_limit',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'default_frist_qualifikation',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'default_frist_geprueft',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'default_frist_bestellung_kunde',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'hash',
        type: 'varchar(10)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'create_activity_log_for_doc',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'allow_sending_bulk_emails',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'project_list_export',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'hash',
        columns: ['hash'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_umsetz_created_by_id_ea24c163_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_umsetz_lastmodified_by_id_b730348e_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_umsetzungspartner_created_at_0e6d7183',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_umsetzungspartner_lastmodified_at_e9489586',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_umsetzungspar_allow_sending_bulk_emails_49999a21',
        columns: ['allow_sending_bulk_emails'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_vertriebsdienstleister: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'firma',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'strasse',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'hausnummer',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'plz',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ort',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_geschlecht',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ansprechpartner_titel',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_anrede',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_vorname',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_nachname',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_telefon',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_email',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'notification_last_sent',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'notification_time_limit',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'hash',
        type: 'varchar(10)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'default_frist_bestellung_kunde',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'default_frist_geprueft',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'default_frist_qualifikation',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'project_list_export',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_2fa_enforced',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_granted_vlink_next_app_api_access',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'create_activity_log_for_doc',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_granted_vlink_sales_app_api_access',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'allow_sending_bulk_emails',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'hash',
        columns: ['hash'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstlei_created_by_id_24b1a1ece768ffd1_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dien_lastmodified_by_id_18a1eaf31ec99b99_fk_account_emailuser_id',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_vertriebsdienstleister_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_vertriebsdienstleister_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'dienstleister_vertriebsdien_allow_sending_bulk_emails_339ca50f',
        columns: ['allow_sending_bulk_emails'],
        type: 'BTREE'
      }
    ]
  },
  energiedach_eegverguetung: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'startdatum',
        type: 'date',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'enddatum',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'einspeiseverguetung_bis_10kw',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'einspeiseverguetung_bis_20kw',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'einspeiseverguetung_bis_1mw',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'degression_einspeiseverguetung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'energieda_created_by_id_41163d616f0b5074_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'ener_lastmodified_by_id_1ed653aeaccd7e8a_fk_account_emailuser_id',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_eegverguetung_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_eegverguetung_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  energiedach_globaleparameter: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'speicherdegradation',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'energiedach_globaleparameter_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_globaleparameter_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_globaleparameter_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_globaleparameter_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      }
    ]
  },
  energiedach_postleitzahlenbereich: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'plz_von',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'plz_bis',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ed_azimut_0',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ed_azimut_90',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ed_azimut_minus_90',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'country',
        type: 'varchar(2)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'energiedach_postleitzahlenbereich_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_postleitzahlenbereich_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_postleitzahlenbereich_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_postleitzahlenbereich_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_postleitzahlenbereich_country_d0ceef3c',
        columns: ['country'],
        type: 'BTREE'
      }
    ]
  },
  energiedach_tetraeder: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'plz',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'street',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'number',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'addition',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'city',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'hid',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'projekt',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: []
  },
  energiespeicher_globaleparameter: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'optimaler_kapazitaetsdurchsatz',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'energiesp_created_by_id_3dcb4a0b4622b1a6_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'ener_lastmodified_by_id_51a2f546a7a3de90_fk_account_emailuser_id',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'energiespeicher_globaleparameter_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'energiespeicher_globaleparameter_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  kunde_branche: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'branche',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: []
  },
  kunde_erreichbarkeit: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'erreichbarkeit_from',
        type: 'time(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'erreichbarkeit_to',
        type: 'time(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'kunde_erreichbarkeit_erreichbarkeit_from_erre_d2b65115_uniq',
        columns: ['erreichbarkeit_from', 'erreichbarkeit_to'],
        type: 'UNIQUE'
      }
    ]
  },
  kunde_postleitzahl: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'plz',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'latitude',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'longitude',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'city',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'country',
        type: 'varchar(2)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'kunde_postleitzahl_country_1982a6f3',
        columns: ['country'],
        type: 'BTREE'
      }
    ]
  },
  kundenportal_kundenportal: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_deleted',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'link_impressum',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'link_datenschutz',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'link_nutzungsbedingungen',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'logo',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'allowed_referrer',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'page_name',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'key',
        type: 'varchar(20)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'text_content',
        type: 'longtext',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'layout',
        type: 'longtext',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'configuration',
        type: 'longtext',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'tracking',
        type: 'longtext',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'message_default',
        type: 'json',
        nullable: false,
        default: '(_utf8mb4\'{"vdl": false',
        constraints: []
      },
      {
        name: 'message_required',
        type: 'json',
        nullable: false,
        default: '(_utf8mb4\'{"vdl": false',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'key',
        columns: ['key'],
        type: 'UNIQUE'
      },
      {
        name: 'kundenportal_kundenp_created_by_id_f1b22cdb_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'kundenportal_kundenp_lastmodified_by_id_b2801656_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'kundenportal_kundenportal_created_at_34a1af42',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'kundenportal_kundenportal_lastmodified_at_2d94caa6',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'kundenportal_kundenportal_is_deleted_23259d42',
        columns: ['is_deleted'],
        type: 'BTREE'
      }
    ]
  },
  mandant_region: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ed_azimut_0',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ed_azimut_90',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ed_azimut_minus_90',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'mandant_region_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'mandant_region_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_region_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'mandant_region_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      }
    ]
  },
  option_option: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(200)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'preis',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_default',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'angebot_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'paket_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'abwaehlbar',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ist_ausgewaehlt',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'in_kundenangebot_enthalten',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'slug',
        type: 'varchar(50)',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'projekt_id',
        columns: ['projekt_id', 'name'],
        type: 'UNIQUE'
      },
      {
        name: 'option_option_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'option_option_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'option_option_6d2603c1',
        columns: ['angebot_id'],
        type: 'BTREE'
      },
      {
        name: 'option_option_e93cb7eb',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'option_option_d880e5da',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'option_option_315f8f0f',
        columns: ['paket_id'],
        type: 'BTREE'
      },
      {
        name: 'option_option_f8111fd1',
        columns: ['projekt_id'],
        type: 'BTREE'
      },
      {
        name: 'option_option_slug_922779f1',
        columns: ['slug'],
        type: 'BTREE'
      }
    ]
  },
  permission_permissiongroup: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'name',
        type: 'varchar(150)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'einstufung',
        type: 'varchar(200)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'alle_produkttypen',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_api_group',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'name',
        columns: ['name'],
        type: 'UNIQUE'
      }
    ]
  },
  permission_platformpermission: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'name',
        type: 'varchar(50)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'codename',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'codename',
        columns: ['codename'],
        type: 'UNIQUE'
      }
    ]
  },
  produkt_produkttyp: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'custom_logo',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'custom_name',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'preisberechnung_aktiv',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'name',
        columns: ['name'],
        type: 'UNIQUE'
      },
      {
        name: 'produkt_produkttyp_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produkttyp_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produkttyp_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produkttyp_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      }
    ]
  },
  projekt_absagegrundkategorie: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'name',
        type: 'varchar(250)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'name',
        columns: ['name'],
        type: 'UNIQUE'
      }
    ]
  },
  projekt_berechnung: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'ergebnis',
        type: 'json',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'auswirkung_fields_cache',
        type: 'json',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: []
  },
  qualifikation_qualificationcategory: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(50)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'slug',
        type: 'varchar(50)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'slug',
        columns: ['slug'],
        type: 'UNIQUE'
      },
      {
        name: 'qualifikation_qualif_created_by_id_f0818308_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_qualif_lastmodified_by_id_0d513107_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_qualificationcategory_created_at_dea3d5e6',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_qualificationcategory_lastmodified_at_7e936b58',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  tags_intern_tag: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'name',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'name',
        columns: ['name'],
        type: 'UNIQUE'
      }
    ]
  },
  tags_tag: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_deleted',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'slug',
        type: 'varchar(50)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'creator_object_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'creator_content_type_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'tags_tag_created_by_id_b7780762_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'tags_tag_creator_content_type_a465bb0f_fk_django_co',
        columns: ['creator_content_type_id'],
        type: 'BTREE'
      },
      {
        name: 'tags_tag_lastmodified_by_id_a59bd7df_fk_account_emailuser_id',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'tags_tag_created_at_9103727d',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'tags_tag_lastmodified_at_6cd91bd9',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'tags_tag_is_deleted_89c183fc',
        columns: ['is_deleted'],
        type: 'BTREE'
      },
      {
        name: 'tags_tag_slug_78c2b8d8',
        columns: ['slug'],
        type: 'BTREE'
      }
    ]
  },
  vertrieb_vertriebskanal: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'slug',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'slug',
        columns: ['slug'],
        type: 'UNIQUE'
      },
      {
        name: 'vertrieb_v_created_by_id_23290bafb693d3a_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'vert_lastmodified_by_id_4b5e0c55fad81dc4_fk_account_emailuser_id',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'vertrieb_vertriebskanal_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'vertrieb_vertriebskanal_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_accessor: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'object_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'object_content_type_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'building_block_creation_count',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'building_kit_creation_count',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'vlink_buildingkit_access_object_content_type_id_o_13164cd6_uniq',
        columns: ['object_content_type_id', 'object_id'],
        type: 'UNIQUE'
      },
      {
        name: 'vlink_buildingkit_accessor_object_id_d8eb42b2',
        columns: ['object_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_buildingunitattachment: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'name',
        type: 'varchar(400)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'file',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'object_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'owner_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'content_type_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'owner_content_type_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'vlink_buildingkit_bu_content_type_id_5cea4262_fk_django_co',
        columns: ['content_type_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_bu_owner_content_type_i_67c26096_fk_django_co',
        columns: ['owner_content_type_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_buildingunitattachment_object_id_bf9b7f03',
        columns: ['object_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_buildingunitattachment_owner_id_7a271bb4',
        columns: ['owner_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_field: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'label',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'slug',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'unit',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'type',
        type: 'varchar(10)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'precision',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'frozen_version_hash',
        type: 'varchar(64)',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [],
    indexes: [
      {
        name: 'vlink_buildingkit_field_slug_26d149b3',
        columns: ['slug'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_field_frozen_version_hash_c387867e',
        columns: ['frozen_version_hash'],
        type: 'BTREE'
      }
    ]
  },
  auth_group_permissions: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'group_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'permission_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'group_id',
        references: 'auth_group(id)'
      },
      {
        column: 'permission_id',
        references: 'auth_permission(id)'
      }
    ],
    indexes: [
      {
        name: 'group_id',
        columns: ['group_id', 'permission_id'],
        type: 'UNIQUE'
      },
      {
        name: 'auth_group_permissions_5f412f9a',
        columns: ['group_id'],
        type: 'BTREE'
      },
      {
        name: 'auth_group_permissions_83d7f98b',
        columns: ['permission_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_fachpartner_regionen: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'fachpartner_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'postleitzahl_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'fachpartner_id',
        references: 'dienstleister_fachpartner(id)'
      },
      {
        column: 'postleitzahl_id',
        references: 'kunde_postleitzahl(id)'
      }
    ],
    indexes: [
      {
        name: 'dienstleister_fachpartne_fachpartner_id_postleitz_00b26de3_uniq',
        columns: ['fachpartner_id', 'postleitzahl_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_fachpa_postleitzahl_id_f607eae0_fk_kunde_pos',
        columns: ['postleitzahl_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_fachpartner_wholesalers: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'fachpartner_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'wholesaler_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'fachpartner_id',
        references: 'dienstleister_fachpartner(id)'
      }
    ],
    indexes: [
      {
        name: 'dienstleister_fachpartne_fachpartner_id_wholesale_8d131fb7_uniq',
        columns: ['fachpartner_id', 'wholesaler_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_fachpa_wholesaler_id_da3e83b1_fk_wholesale',
        columns: ['wholesaler_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_fachpartnerprodukttyp: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'fachpartner_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'produkttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'agb',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'fachpartner_id',
        references: 'dienstleister_fachpartner(id)'
      },
      {
        column: 'produkttyp_id',
        references: 'produkt_produkttyp(id)'
      }
    ],
    indexes: [
      {
        name: 'dienstleister_fachpartne_fachpartner_id_produktty_e2345f3f_uniq',
        columns: ['fachpartner_id', 'produkttyp_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_fachpa_produkttyp_id_12c11d21_fk_produkt_p',
        columns: ['produkttyp_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_systempartner_fachpartner: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'systempartner_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'fachpartner_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'fachpartner_id',
        references: 'dienstleister_fachpartner(id)'
      },
      {
        column: 'systempartner_id',
        references: 'dienstleister_systempartner(id)'
      }
    ],
    indexes: [
      {
        name: 'dienstleister_systempart_systempartner_id_fachpar_b7297c10_uniq',
        columns: ['systempartner_id', 'fachpartner_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_system_fachpartner_id_494fe0c7_fk_dienstlei',
        columns: ['fachpartner_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_systempartnerprodukttyp: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'systempartner_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'produkttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'agb',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'default_marge',
        type: 'decimal(6,2)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'produkttyp_id',
        references: 'produkt_produkttyp(id)'
      },
      {
        column: 'systempartner_id',
        references: 'dienstleister_systempartner(id)'
      }
    ],
    indexes: [
      {
        name: 'dienstleister_systempart_systempartner_id_produkt_8018f003_uniq',
        columns: ['systempartner_id', 'produkttyp_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_system_produkttyp_id_349e716b_fk_produkt_p',
        columns: ['produkttyp_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_umsetzungspartnerprodukttyp: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'umsetzungspartner_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'produkttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'produkttyp_id',
        references: 'produkt_produkttyp(id)'
      },
      {
        column: 'umsetzungspartner_id',
        references: 'dienstleister_umsetzungspartner(id)'
      }
    ],
    indexes: [
      {
        name: 'dienstleister_umsetzungs_umsetzungspartner_id_pro_ef96be8d_uniq',
        columns: ['umsetzungspartner_id', 'produkttyp_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_umsetz_produkttyp_id_6b6d2efc_fk_produkt_p',
        columns: ['produkttyp_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_vdlprodukttyp: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'vertriebsdienstleister_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'produkttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'vertriebsdienstleister_id',
        references: 'dienstleister_vertriebsdienstleister(id)'
      },
      {
        column: 'produkttyp_id',
        references: 'produkt_produkttyp(id)'
      }
    ],
    indexes: [
      {
        name: 'vertriebsdienstleister_id',
        columns: ['vertriebsdienstleister_id', 'produkttyp_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstle_produkttyp_id_454495ea0c540a16_fk_produkt_produkttyp_id',
        columns: ['produkttyp_id'],
        type: 'BTREE'
      }
    ]
  },
  dokument_dokumentkategorie: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'name',
        type: 'varchar(50)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lft',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'rght',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'tree_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'level',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'parent_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_fuerkunden',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'typ',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_indikativangebot',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'parent_id',
        references: 'dokument_dokumentkategorie(id)'
      }
    ],
    indexes: [
      {
        name: 'dokument_dokumentkategorie_656442a0',
        columns: ['tree_id'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentkategorie_6be37982',
        columns: ['parent_id'],
        type: 'BTREE'
      }
    ]
  },
  dynamic_dynamicparametertemplate: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'vertragslaufzeit',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'mwst_satz',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kalkulationszinsfuss',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'inflationsrate',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kostensteigerungsrate',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'marge_absolut',
        type: 'decimal(7,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'marge_relativ',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'rabatt_absolut',
        type: 'decimal(7,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'rabatt_relativ',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'arbeitspreis',
        type: 'decimal(5,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'arbeitspreis_einheit',
        type: 'varchar(10)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'preis_einheit_laufend',
        type: 'varchar(10)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'preis_einheit_kauf',
        type: 'varchar(10)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'produkttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'additional_margin_absolute',
        type: 'decimal(7,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'additional_margin_relative',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'produkttyp_id',
        references: 'produkt_produkttyp(id)'
      }
    ],
    indexes: [
      {
        name: 'unique_product_type',
        columns: ['produkttyp_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dynamic_dynamicparam_created_by_id_b570d17d_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamicparam_lastmodified_by_id_320e507b_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamicparametertemplate_created_at_1a9397cb',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamicparametertemplate_lastmodified_at_4acaed51',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  permission_permissiongroup_permissions: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'permissiongroup_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'platformpermission_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'permissiongroup_id',
        references: 'permission_permissiongroup(id)'
      },
      {
        column: 'platformpermission_id',
        references: 'permission_platformpermission(id)'
      }
    ],
    indexes: [
      {
        name: 'tpedgroup_id',
        columns: ['permissiongroup_id', 'platformpermission_id'],
        type: 'UNIQUE'
      },
      {
        name: 'permission_tpedgroup_permissions_6671cda4',
        columns: ['permissiongroup_id'],
        type: 'BTREE'
      },
      {
        name: 'permission_tpedgroup_permissions_bf3c1fb7',
        columns: ['platformpermission_id'],
        type: 'BTREE'
      }
    ]
  },
  permission_permissiongroup_produkttypen: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'permissiongroup_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'produkttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'produkttyp_id',
        references: 'produkt_produkttyp(id)'
      },
      {
        column: 'permissiongroup_id',
        references: 'permission_permissiongroup(id)'
      }
    ],
    indexes: [
      {
        name: 'tpedgroup_id',
        columns: ['permissiongroup_id', 'produkttyp_id'],
        type: 'UNIQUE'
      },
      {
        name: 'permissi_produkttyp_id_4935b45295f0066b_fk_produkt_produkttyp_id',
        columns: ['produkttyp_id'],
        type: 'BTREE'
      }
    ]
  },
  produkt_produkt: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'uid',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'typ_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'activate_building_kit_features',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'typ_id',
        references: 'produkt_produkttyp(id)'
      }
    ],
    indexes: [
      {
        name: 'uid',
        columns: ['uid'],
        type: 'UNIQUE'
      },
      {
        name: 'produkt_produkt_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produkt_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produkt_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produkt_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produkt_14f1260a',
        columns: ['typ_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_pro_id_881091_idx',
        columns: ['id', 'typ_id'],
        type: 'BTREE'
      }
    ]
  },
  projekt_absagegrund: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'name',
        type: 'varchar(250)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kategorie_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'kategorie_id',
        references: 'projekt_absagegrundkategorie(id)'
      }
    ],
    indexes: [
      {
        name: 'name',
        columns: ['name'],
        type: 'UNIQUE'
      },
      {
        name: 'projekt_absagegrund_cc745a5b',
        columns: ['kategorie_id'],
        type: 'BTREE'
      }
    ]
  },
  qualifikation_basisprojektqualifikationsparameter: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_deleted',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'typ',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'short_title',
        type: 'varchar(70)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'platzhalter',
        type: 'varchar(22)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'category_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'category_id',
        references: 'qualifikation_qualificationcategory(id)'
      }
    ],
    indexes: [
      {
        name: 'short_title',
        columns: ['short_title'],
        type: 'UNIQUE'
      },
      {
        name: 'platzhalter',
        columns: ['platzhalter'],
        type: 'UNIQUE'
      },
      {
        name: 'qualifikation_basisp_created_by_id_c6ee1803_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_basisp_lastmodified_by_id_c059387b_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_basisprojektq_created_at_505aab9b',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_basisprojektq_lastmodified_at_ae153a43',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_basisprojektq_is_deleted_6cf489fd',
        columns: ['is_deleted'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_basisprojektqualifikationsparameter_typ_08c1fade',
        columns: ['typ'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_basisp_category_id_1ed0ec72_fk_qualifika',
        columns: ['category_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_fieldchoice: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'value',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'field_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'frozen_version_hash',
        type: 'varchar(64)',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'field_id',
        references: 'vlink_buildingkit_field(id)'
      }
    ],
    indexes: [
      {
        name: 'vlink_buildingkit_fi_field_id_ee446daf_fk_vlink_bui',
        columns: ['field_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_fieldchoice_value_37031bd3',
        columns: ['value'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_fieldchoice_frozen_version_hash_32e85964',
        columns: ['frozen_version_hash'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_tradingmarginrelation: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'trading_margin',
        type: 'decimal(6,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'category_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'consumer_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'owner_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'category_id',
        references: 'produkt_produkt(id)'
      },
      {
        column: 'consumer_id',
        references: 'vlink_buildingkit_accessor(id)'
      },
      {
        column: 'owner_id',
        references: 'vlink_buildingkit_accessor(id)'
      }
    ],
    indexes: [
      {
        name: 'vlink_buildingkit_tradin_owner_id_consumer_id_cat_c77a8424_uniq',
        columns: ['owner_id', 'consumer_id', 'category_id'],
        type: 'UNIQUE'
      },
      {
        name: 'vlink_buildingkit_tr_category_id_c48ddfae_fk_produkt_p',
        columns: ['category_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_tr_consumer_id_bacc1c30_fk_vlink_bui',
        columns: ['consumer_id'],
        type: 'BTREE'
      }
    ]
  },
  paket_paket: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'beschreibung',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'lieferant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'produkt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ist_fixiert',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'original_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ist_individuell',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'leistung_individuell',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lieferant_individuell',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'preis_individuell',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lieferant_adresse_individuell',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'nutzkapazitaet_individuell',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'paketschluessel',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'moduletyp_individuell',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'montagesystem_individuell',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'speichertyp_individuell',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'wechselrichtertyp_individuell',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ist_archiviert',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'foerdersumme',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'uuid',
        type: 'char(32)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'lieferant_id',
        references: 'dienstleister_systempartner(id)'
      },
      {
        column: 'original_id',
        references: 'paket_paket(id)'
      },
      {
        column: 'produkt_id',
        references: 'produkt_produkt(id)'
      }
    ],
    indexes: [
      {
        name: 'paket_paket_uuid_bbc6db78_uniq',
        columns: ['uuid'],
        type: 'UNIQUE'
      },
      {
        name: 'paket_paket_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'paket_paket_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'paket_paket_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'paket_paket_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'paket_paket_c9e90e4e',
        columns: ['lieferant_id'],
        type: 'BTREE'
      },
      {
        name: 'paket_paket_4a0f543a',
        columns: ['produkt_id'],
        type: 'BTREE'
      },
      {
        name: 'paket_paket_524b09d0',
        columns: ['original_id'],
        type: 'BTREE'
      }
    ]
  },
  paket_paketfreifeld: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'name',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'pos',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'typ',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'value_text',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'value_float',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'paket_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'filter_id',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'paket_id',
        references: 'paket_paket(id)'
      }
    ],
    indexes: [
      {
        name: 'paket_paketfreifeld_paket_id_52ba694e_fk_paket_paket_id',
        columns: ['paket_id'],
        type: 'BTREE'
      },
      {
        name: 'paket_paketfreifeld_typ_4d9895bc',
        columns: ['typ'],
        type: 'BTREE'
      }
    ]
  },
  paket_paketfrontendinformation: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'description',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'image',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'paket_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: '_name',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'highlight_banner_is_active',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'highlight_banner',
        type: 'varchar(160)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'paket_id',
        references: 'paket_paket(id)'
      }
    ],
    indexes: [
      {
        name: 'paket_id',
        columns: ['paket_id'],
        type: 'UNIQUE'
      },
      {
        name: 'paket_paketfrontendi_created_by_id_3e013a15_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'paket_paketfrontendi_lastmodified_by_id_52af98d5_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'paket_paketfrontendinformation_created_at_17bf6bed',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'paket_paketfrontendinformation_lastmodified_at_ecfccd46',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  paket_paketfrontendkurzbeschreibung: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'slug',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'text',
        type: 'varchar(160)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'paket_frontend_information_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'paket_frontend_information_id',
        references: 'paket_paketfrontendinformation(id)'
      }
    ],
    indexes: [
      {
        name: 'paket_paketfrontendkurzb_paket_frontend_informati_03b0e8cd_uniq',
        columns: ['paket_frontend_information_id', 'slug'],
        type: 'UNIQUE'
      },
      {
        name: 'paket_paketfrontendk_created_by_id_2b66db6d_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'paket_paketfrontendk_lastmodified_by_id_11420a1c_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'paket_paketfrontendkurzbeschreibung_created_at_fb6052c2',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'paket_paketfrontendkurzbeschreibung_lastmodified_at_0b18dea3',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'paket_paketfrontendkurzbeschreibung_slug_6dd8c028',
        columns: ['slug'],
        type: 'BTREE'
      }
    ]
  },
  dynamic_dynamicpaket: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'paket_preis',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'paket_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'available_in_frontend',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'paket_id',
        references: 'paket_paket(id)'
      }
    ],
    indexes: [
      {
        name: 'paket_id',
        columns: ['paket_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dynamic_dynamicpaket_created_by_id_75c19158_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamicpaket_lastmodified_by_id_db77903f_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamicpaket_created_at_d1f30cf9',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamicpaket_lastmodified_at_6aae985c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  energiespeicher_espeicherpaket: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'batterie_nutzkapazitaet',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'batterie_max_beladeleistung',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'batterie_max_entladeleistung',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'paket_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'modell',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'montageart',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'paket_preis',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'wechselrichtertyp',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'energiemanagement',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'speichersystem',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'anzahl_phasen',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'paket_id',
        references: 'paket_paket(id)'
      }
    ],
    indexes: [
      {
        name: 'paket_id',
        columns: ['paket_id'],
        type: 'UNIQUE'
      },
      {
        name: 'energiesp_created_by_id_665cb416f1cd5c2e_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'ener_lastmodified_by_id_5e7387940c66bba4_fk_account_emailuser_id',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'energiespeicher_espeicherpaket_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'energiespeicher_espeicherpaket_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  energiedach_edleistungspaket: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'paket_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'leistung_von',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'leistung_bis',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'benoetigte_dachflaeche',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'hardware_kosten',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'montage_preis',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'modultyp',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'montagesystem',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'wechselrichtertyp',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_flachdach',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'speicherpaket_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ac_bemessungsstrom',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ac_nennspannung',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'anzahl_phasen',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'bemessungsleistung',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'einspeisung_l1',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'einspeisung_l2',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'einspeisung_l3',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'kurzschlussstrom',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'max_ac_scheinleistung',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'pulsfrequenz',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_satteldach',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'anzahl_module',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'speicherpaket_id',
        references: 'energiespeicher_espeicherpaket(id)'
      },
      {
        column: 'paket_id',
        references: 'paket_paket(id)'
      }
    ],
    indexes: [
      {
        name: 'paket_id',
        columns: ['paket_id'],
        type: 'UNIQUE'
      },
      {
        name: 'energiedach_edleistungspaket_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_edleistungspaket_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_edleistungspaket_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_edleistungspaket_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_edleistungspaket_43e4f839',
        columns: ['speicherpaket_id'],
        type: 'BTREE'
      }
    ]
  },
  abwicklung_abwicklung: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ver_unterschrieben',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_beauftragt',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'wub_wartungdurch',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_unterschrdat',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_widerrfrablauf',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_kundenterm',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'nan_nvpnotwend',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'nan_antragnvpdat',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'nan_empfergebnvp',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'nan_ergebnvp',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'nan_fertigmelddat',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'nan_zaehlersetzterm',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_objektbegehterm',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_lieferterm',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_lieferort',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_kundenwuensche',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'lum_montageterm',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_abnahmeterm',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'wub_wartungszykl',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'pro_intauftrnrsw',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'pro_intauftrnrsp',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'pro_intauftrnrfp',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'nan_inbetriebnahmeterm',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_vertriebtermin',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fpa_anzahlurgfpanspdat',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fpa_anzahlurgfpanspnetsum',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fpa_anzahlurgfpanspstatus',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fpa_auftrspanfpnetsum',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fpa_rgfpanspdat',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fpa_rgfpanspnetsum',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fpa_rgfpanspstatus',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'nan_eintragmastrdat',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_bonipruefungdat',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'nan_zaehlernum',
        type: 'varchar(30)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'nan_zaehlerst',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_vorkasseanteil',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_abschlgespterm',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dok_versdokterm',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'foe_foerdbeantrtermbeg',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'foe_foerdstatusbeg',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dok_heizlast',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'foe_foerdbeantrsumbeg',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'foe_foerdbestdatbeg',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'foe_foerdbewsumbeg',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_kundenterm2',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_objektbegehterm2',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_montagetermac',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_montagetermdc',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_montagetermrest',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_lieferant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'foe_foerdbeaufttern',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_erlaeutgespraterm',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dok_anlagenplaner_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'foe_foerdstatusregio',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dok_technibetriebsbereit',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'foe_bezregionalesfoerdpro',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'foe_foerdbeantrsumregio',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'foe_foerdbeantrtermregio',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'foe_foerdbestdatregio',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'foe_foerdbewsumregio',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'foe_regionalesfoer',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fpa_auftragspanfpange',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_vertriebtermin2',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_wartungsfensterbis',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_wartungsfenstervon',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_wartungsjahr',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_wartungstermin',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_wartungstermin2',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_aktuellesvertragsende',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_autverlaeintervvertrag',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_autverlaevertrag',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_kuendigungsfrist',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_kuendigungsfristintervall',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_vertraggekuendigtam',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_vertragsbeginnwartung',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_vertragsendewartung',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_wartungsintervall',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'wub_fachpartner_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'wub_vertragsbeginnwartung',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'wub_vertragsendewartung',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lum_vollstbetriebsbereit',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fpa_sumkostspausfprechn',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'nan_verteilnb',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'nan_wbanmdat',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dok_inbetriebnahme',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dok_abnahme',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fpa_ntsntspanfp',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_endkundenpreisext',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ver_vkid',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_kostenafm',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_anderemodulanz',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_apzinstallierbar',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_batteriebedingungen',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_begruendapz',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendbatterie',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruenddachzustand',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendeinbringungsweg',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendheizkoerperauf',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendhktausch',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendhydraulikschema',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendmehraufwand',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendmesskonzept',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendmesskonzeptb',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendplatzangebot',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendprojekthw',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendpvanbindung',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendsparrenabstand',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendsparrenbreite',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendthermostatv',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendwallboxleitung',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendwandbrueche',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendwr',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_begruendzusatzaufwaende',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_dachzustand',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_dcleitungausr',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_dcleitungmeter',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_einbringungswegausr',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_gerustausreichend',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_hakzuleitungmeter',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_hakzuleitungneu',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_heizkoerperaufgenommen',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_hktauschnoetig',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_hydraulikschemakorrekt',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_mehraufwandzusatz',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_messkonzeptbesprochen',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_messkonzeptumsetzbar',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_modulumsetzbar',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_mzusatzgerust',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_ortwallboxzusatz',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'afm_platzangebotwaermeerz',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_potentialausgleichvorh',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_projekthwumsetzbar',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_pvanbindungzschr',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_sparrenabstandausr',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_sparrenbreiteausr',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_thermostatvabgedeckt',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_wallboxleitungausreicht',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_wandbruecheanz',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_wanddurchbruecheanz',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_wanddurchbruechenoetig',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_wrbedingungen',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'afm_zusatzaufwaendebeachten',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      },
      {
        column: 'dok_anlagenplaner_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'lum_lieferant_id',
        references: 'abwicklung_hardwarelieferant(id)'
      },
      {
        column: 'wub_fachpartner_id',
        references: 'dienstleister_fachpartner(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_id',
        columns: ['projekt_id'],
        type: 'UNIQUE'
      },
      {
        name: 'abwicklung_created_by_id_c422b5cd11e8764_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'abwi_lastmodified_by_id_37c2d55f0829566e_fk_account_emailuser_id',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'abwicklung_abwicklung_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'abwicklung_abwicklung_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'abwicklung_abwicklun_lum_lieferant_id_21896fd7_fk_abwicklun',
        columns: ['lum_lieferant_id'],
        type: 'BTREE'
      },
      {
        name: 'abwicklung_abwicklun_dok_anlagenplaner_id_325a9dc8_fk_account_e',
        columns: ['dok_anlagenplaner_id'],
        type: 'BTREE'
      },
      {
        name: 'abwicklung_abwicklun_wub_fachpartner_id_7cc560d5_fk_dienstlei',
        columns: ['wub_fachpartner_id'],
        type: 'BTREE'
      }
    ]
  },
  abwicklung_abwicklungmedia: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'feldname',
        type: 'varchar(80)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'file',
        type: 'varchar(600)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'abwicklung_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'abwicklung_id',
        references: 'abwicklung_abwicklung(id)'
      }
    ],
    indexes: [
      {
        name: 'abwic_abwicklung_id_6a0c15aee7332c86_fk_abwicklung_abwicklung_id',
        columns: ['abwicklung_id'],
        type: 'BTREE'
      },
      {
        name: 'abwicklun_created_by_id_69653ae8c0df8ab7_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'abwi_lastmodified_by_id_62e203f038581a81_fk_account_emailuser_id',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'abwicklung_abwicklungmedia_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'abwicklung_abwicklungmedia_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  account_account: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'password',
        type: 'varchar(128)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'last_login',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'email',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'status',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'secret_key',
        type: 'varchar(128)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      }
    ],
    indexes: [
      {
        name: 'account_account_mandant_id_email_ff27be78_uniq',
        columns: ['mandant_id', 'email'],
        type: 'UNIQUE'
      },
      {
        name: 'account_account_created_by_id_a1fadc00_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'account_account_lastmodified_by_id_786dec91_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'account_account_created_at_41a6adaf',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'account_account_lastmodified_at_f5b7d8f2',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  account_emailuser: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'password',
        type: 'varchar(128)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'last_login',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'email',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lieferant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'first_name',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'last_name',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_active',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_admin',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_demo_user',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'show_tguide_help',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'groups_produkttypspezifisch',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vdl_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'api_requests_rate',
        type: 'varchar(40)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'additional_information',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'department',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'home_telephone',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mobile_telephone',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'profile_picture',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'secret_key',
        type: 'varchar(128)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fallback_email',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_fallback_email_deactivated',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'fachpartner_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'accepted_rechtliches',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'usp_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'fachpartner_id',
        references: 'dienstleister_fachpartner(id)'
      },
      {
        column: 'lieferant_id',
        references: 'dienstleister_systempartner(id)'
      },
      {
        column: 'usp_id',
        references: 'dienstleister_umsetzungspartner(id)'
      },
      {
        column: 'vdl_id',
        references: 'dienstleister_vertriebsdienstleister(id)'
      },
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      }
    ],
    indexes: [
      {
        name: 'email',
        columns: ['email'],
        type: 'UNIQUE'
      },
      {
        name: 'fallback_email',
        columns: ['fallback_email'],
        type: 'UNIQUE'
      },
      {
        name: 'account_emailuser_8b7ae3af',
        columns: ['mandant_id'],
        type: 'BTREE'
      },
      {
        name: 'account_emailuser_c9e90e4e',
        columns: ['lieferant_id'],
        type: 'BTREE'
      },
      {
        name: 'account_emailuser_55f56498',
        columns: ['is_active'],
        type: 'BTREE'
      },
      {
        name: 'account_emailuser_32512944',
        columns: ['is_admin'],
        type: 'BTREE'
      },
      {
        name: 'account_emailuser_56964e0a',
        columns: ['vdl_id'],
        type: 'BTREE'
      },
      {
        name: 'account_ema_id_d94cd6_idx',
        columns: ['id', 'lieferant_id'],
        type: 'BTREE'
      },
      {
        name: 'account_ema_id_81bb9f_idx',
        columns: ['id', 'mandant_id'],
        type: 'BTREE'
      },
      {
        name: 'account_ema_id_9d5487_idx',
        columns: ['id', 'vdl_id'],
        type: 'BTREE'
      },
      {
        name: 'account_ema_id_ef4c4b_idx',
        columns: ['id', 'fachpartner_id'],
        type: 'BTREE'
      },
      {
        name: 'account_emailuser_fachpartner_id_637e0d09_fk_dienstlei',
        columns: ['fachpartner_id'],
        type: 'BTREE'
      },
      {
        name: 'account_emailuser_usp_id_6806714e_fk_dienstlei',
        columns: ['usp_id'],
        type: 'BTREE'
      },
      {
        name: 'account_ema_id_8c8415_idx',
        columns: ['id', 'usp_id'],
        type: 'BTREE'
      }
    ]
  },
  account_emailuser_vertriebskanaele: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'emailuser_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertriebskanal_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'emailuser_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'vertriebskanal_id',
        references: 'vertrieb_vertriebskanal(id)'
      }
    ],
    indexes: [
      {
        name: 'emailuser_id',
        columns: ['emailuser_id', 'vertriebskanal_id'],
        type: 'UNIQUE'
      },
      {
        name: 'b2e319038cd14deecb1b9049786e7bd2',
        columns: ['vertriebskanal_id'],
        type: 'BTREE'
      }
    ]
  },
  account_emailusergroup: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'emailuser_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'group_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'produkttyp_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'produkttyp_id',
        references: 'produkt_produkttyp(id)'
      },
      {
        column: 'emailuser_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'group_id',
        references: 'permission_permissiongroup(id)'
      }
    ],
    indexes: [
      {
        name: 'account_emailusergroup_emailuser_id_2341a58db822762c_uniq',
        columns: ['emailuser_id', 'group_id', 'produkttyp_id'],
        type: 'UNIQUE'
      },
      {
        name: 'account_emailusergroup_eb9384ff',
        columns: ['emailuser_id'],
        type: 'BTREE'
      },
      {
        name: 'account_emailusergroup_0e939a4f',
        columns: ['group_id'],
        type: 'BTREE'
      },
      {
        name: 'account_emailusergroup_5f3bdd18',
        columns: ['produkttyp_id'],
        type: 'BTREE'
      }
    ]
  },
  account_emailuserotpemaildevice: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'name',
        type: 'varchar(64)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'confirmed',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'token',
        type: 'varchar(16)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'valid_until',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'throttling_failure_timestamp',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'throttling_failure_count',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'user_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'user_id',
        references: 'account_emailuser(id)'
      }
    ],
    indexes: [
      {
        name: 'user_id',
        columns: ['user_id'],
        type: 'UNIQUE'
      }
    ]
  },
  account_hashedtoken: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'key',
        type: 'varchar(128)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'user_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'user_id',
        references: 'account_emailuser(id)'
      }
    ],
    indexes: [
      {
        name: 'key',
        columns: ['key'],
        type: 'UNIQUE'
      },
      {
        name: 'user_id',
        columns: ['user_id'],
        type: 'UNIQUE'
      }
    ]
  },
  angebot_angebot: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'beauftragt_am',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'status',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'dokument',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'preis',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'begruendung_abweichung',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'agb',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lieferant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'agb_accepted',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'agb_accepted_at',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'angebot_accepted',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'angebot_accepted_at',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_deleted',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'dokument_beauftragt',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dokument_vorlage',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'typ',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'dokument_hash',
        type: 'bigint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'reserved_order',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'initial_dokument_hash',
        type: 'bigint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'building_kit_id',
        type: 'bigint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'kind',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      },
      {
        column: 'building_kit_id',
        references: 'vlink_buildingkit_buildingkit(id)'
      },
      {
        column: 'lieferant_id',
        references: 'dienstleister_systempartner(id)'
      }
    ],
    indexes: [
      {
        name: 'angebot_angebot_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'angebot_angebot_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'angebot_angebot_9acb4454',
        columns: ['status'],
        type: 'BTREE'
      },
      {
        name: 'angebot_angebot_e93cb7eb',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'angebot_angebot_d880e5da',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'angebot_angebot_f8111fd1',
        columns: ['projekt_id'],
        type: 'BTREE'
      },
      {
        name: 'angebot_angebot_a07dc71a',
        columns: ['lieferant_id'],
        type: 'BTREE'
      },
      {
        name: 'angebot_angebot_f49e2553',
        columns: ['is_deleted'],
        type: 'BTREE'
      },
      {
        name: 'angebot_angebot_51477bf0',
        columns: ['typ'],
        type: 'BTREE'
      },
      {
        name: 'angebot_angebot_building_kit_id_ea489d14_fk_vlink_bui',
        columns: ['building_kit_id'],
        type: 'BTREE'
      },
      {
        name: 'angebot_angebot_kind_64b06478',
        columns: ['kind'],
        type: 'BTREE'
      }
    ]
  },
  angebot_indication: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_deleted',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'dokument',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lieferant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'paket_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'lieferant_id',
        references: 'dienstleister_systempartner(id)'
      },
      {
        column: 'paket_id',
        references: 'paket_paket(id)'
      },
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      }
    ],
    indexes: [
      {
        name: 'angebot_indication_created_by_id_cea742f3_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'angebot_indication_lastmodified_by_id_2d839b9d_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'angebot_indication_lieferant_id_956b9703_fk_dienstlei',
        columns: ['lieferant_id'],
        type: 'BTREE'
      },
      {
        name: 'angebot_indication_projekt_id_5ee4940a_fk_projekt_projekt_id',
        columns: ['projekt_id'],
        type: 'BTREE'
      },
      {
        name: 'angebot_indication_created_at_31ded248',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'angebot_indication_lastmodified_at_de44acf8',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'angebot_indication_is_deleted_95a116c5',
        columns: ['is_deleted'],
        type: 'BTREE'
      },
      {
        name: 'angebot_indication_paket_id_1644c085_fk_paket_paket_id',
        columns: ['paket_id'],
        type: 'BTREE'
      }
    ]
  },
  authtoken_token: {
    columns: [
      {
        name: 'key',
        type: 'varchar(40)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'user_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['key'],
    foreignKeys: [
      {
        column: 'user_id',
        references: 'account_emailuser(id)'
      }
    ],
    indexes: [
      {
        name: 'user_id',
        columns: ['user_id'],
        type: 'UNIQUE'
      }
    ]
  },
  baukasten_welt_buildingkitfrontendinformation: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_published',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'description',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'highlight_banner',
        type: 'varchar(160)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'highlight_banner_is_active',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'image',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'building_kit_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'building_kit_id',
        references: 'vlink_buildingkit_buildingkit(id)'
      },
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      }
    ],
    indexes: [
      {
        name: 'baukasten_welt_build_building_kit_id_18846a66_fk_vlink_bui',
        columns: ['building_kit_id'],
        type: 'BTREE'
      },
      {
        name: 'baukasten_welt_build_created_by_id_63f84f9d_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'baukasten_welt_build_lastmodified_by_id_06b0746c_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'baukasten_welt_build_mandant_id_18639181_fk_mandant_m',
        columns: ['mandant_id'],
        type: 'BTREE'
      },
      {
        name: 'baukasten_welt_buildingkitf_created_at_20c92100',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'baukasten_welt_buildingkitf_lastmodified_at_d611e0d2',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  baukasten_welt_buildingkitfrontendshortdescription: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'text',
        type: 'varchar(160)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'building_kit_frontend_information_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'building_kit_frontend_information_id',
        references: 'baukasten_welt_buildingkitfrontendinformation(id)'
      }
    ],
    indexes: [
      {
        name: 'baukasten_welt_build_created_by_id_bd64d6e0_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'baukasten_welt_build_lastmodified_by_id_7a5e50a8_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'baukasten_welt_buildingkitf_created_at_c0c825ab',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'baukasten_welt_buildingkitf_lastmodified_at_5fd862c3',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'baukasten_welt_buildingkitf_building_kit_frontend_infor_7824a82c',
        columns: ['building_kit_frontend_information_id'],
        type: 'BTREE'
      }
    ]
  },
  bestellung_bestellung: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bestellt_am',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'geschlossen_am',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'status',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bestellt_von_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'dokumentation_kfm',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'bestellt_von_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      }
    ],
    indexes: [
      {
        name: 'bestellung_bestellung_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'bestellung_bestellung_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'bestellung_bestellung_9acb4454',
        columns: ['status'],
        type: 'BTREE'
      },
      {
        name: 'bestellung_bestellung_7d22c2ab',
        columns: ['bestellt_von_id'],
        type: 'BTREE'
      },
      {
        name: 'bestellung_bestellung_e93cb7eb',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'bestellung_bestellung_d880e5da',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'bestellung_bestellung_f8111fd1',
        columns: ['projekt_id'],
        type: 'BTREE'
      }
    ]
  },
  core_attachment: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(400)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'file',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'content_type_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'object_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'owner_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_public',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'owner_id',
        references: 'mandant_mandant(id)'
      }
    ],
    indexes: [
      {
        name: 'core_attachment_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'core_attachment_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'core_attachment_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'core_attachment_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'core_attachment_37ef4eb4',
        columns: ['content_type_id'],
        type: 'BTREE'
      },
      {
        name: 'core_attachment_cb902d83',
        columns: ['owner_id'],
        type: 'BTREE'
      },
      {
        name: 'core_attachment_object_id_87756740',
        columns: ['object_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_fachpartner_email_forward_to: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'fachpartner_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'emailuser_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'emailuser_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'fachpartner_id',
        references: 'dienstleister_fachpartner(id)'
      }
    ],
    indexes: [
      {
        name: 'dienstleister_fachpartne_fachpartner_id_emailuser_24222782_uniq',
        columns: ['fachpartner_id', 'emailuser_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_fachpa_emailuser_id_8ec9f8db_fk_account_e',
        columns: ['emailuser_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_fachpartner_mandanten: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'fachpartner_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'fachpartner_id',
        references: 'dienstleister_fachpartner(id)'
      },
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      }
    ],
    indexes: [
      {
        name: 'dienstleister_fachpartne_fachpartner_id_mandant_i_185bb8f4_uniq',
        columns: ['fachpartner_id', 'mandant_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_fachpa_mandant_id_046497a0_fk_mandant_m',
        columns: ['mandant_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_fachpartnerprodukttyp_notify_users_angebot: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'fachpartnerprodukttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'emailuser_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'emailuser_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'fachpartnerprodukttyp_id',
        references: 'dienstleister_fachpartnerprodukttyp(id)'
      }
    ],
    indexes: [
      {
        name: 'dienstleister_fachpartne_fachpartnerprodukttyp_id_faa76a7a_uniq',
        columns: ['fachpartnerprodukttyp_id', 'emailuser_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_fachpa_emailuser_id_52f142e8_fk_account_e',
        columns: ['emailuser_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_systempartner_email_forward_to: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'systempartner_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'emailuser_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'emailuser_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'systempartner_id',
        references: 'dienstleister_systempartner(id)'
      }
    ],
    indexes: [
      {
        name: 'dienstleister_systempart_systempartner_id_emailus_45ab1788_uniq',
        columns: ['systempartner_id', 'emailuser_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_system_emailuser_id_a06c0133_fk_account_e',
        columns: ['emailuser_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_systempartner_mandanten: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'systempartner_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      },
      {
        column: 'systempartner_id',
        references: 'dienstleister_systempartner(id)'
      }
    ],
    indexes: [
      {
        name: 'dienstleister_systempart_systempartner_id_mandant_d2cc8735_uniq',
        columns: ['systempartner_id', 'mandant_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_system_mandant_id_c6aad71a_fk_mandant_m',
        columns: ['mandant_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_systempartnerprodukttyp_notify_users_angebot: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'systempartnerprodukttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'emailuser_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'emailuser_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'systempartnerprodukttyp_id',
        references: 'dienstleister_systempartnerprodukttyp(id)'
      }
    ],
    indexes: [
      {
        name: 'dienstleister_systempart_systempartnerprodukttyp__396f1045_uniq',
        columns: ['systempartnerprodukttyp_id', 'emailuser_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_system_emailuser_id_f1db90cd_fk_account_e',
        columns: ['emailuser_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_systempartnerprodukttyp_notify_users_auftrag: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'systempartnerprodukttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'emailuser_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'emailuser_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'systempartnerprodukttyp_id',
        references: 'dienstleister_systempartnerprodukttyp(id)'
      }
    ],
    indexes: [
      {
        name: 'dienstleister_systempart_systempartnerprodukttyp__aff9900b_uniq',
        columns: ['systempartnerprodukttyp_id', 'emailuser_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_system_emailuser_id_c39ec76f_fk_account_e',
        columns: ['emailuser_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_umsetzungspartnerprodukttyp_notify_users_freigabe: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'umsetzungspartnerprodukttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'emailuser_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'emailuser_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'umsetzungspartnerprodukttyp_id',
        references: 'dienstleister_umsetzungspartnerprodukttyp(id)'
      }
    ],
    indexes: [
      {
        name: 'dienstleister_umsetzungs_umsetzungspartnerprodukt_8214ba85_uniq',
        columns: ['umsetzungspartnerprodukttyp_id', 'emailuser_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_umsetz_emailuser_id_c419541b_fk_account_e',
        columns: ['emailuser_id'],
        type: 'BTREE'
      }
    ]
  },
  dienstleister_vdlprodukttyp_notify_users_freigabe: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'vdlprodukttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'emailuser_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'emailuser_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'vdlprodukttyp_id',
        references: 'dienstleister_vdlprodukttyp(id)'
      }
    ],
    indexes: [
      {
        name: 'dienstleister_vdlprodukt_vdlprodukttyp_id_emailus_d29febbb_uniq',
        columns: ['vdlprodukttyp_id', 'emailuser_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dienstleister_vdlpro_emailuser_id_ea395efa_fk_account_e',
        columns: ['emailuser_id'],
        type: 'BTREE'
      }
    ]
  },
  dokument_dokumentvorlage: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'name',
        type: 'varchar(50)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_active',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'template_file',
        type: 'varchar(600)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lieferant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'template_html',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'typ',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'freigabe_vdl',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vdl_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'betreff',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_default',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kategorie_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'freigabe_fachpartner',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertragsmodell',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'template_file_allows_pdf',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'fachpartner_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'usp_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'freigabe_usp',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'signature_1',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'signature_2',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'vdl_id',
        references: 'dienstleister_vertriebsdienstleister(id)'
      },
      {
        column: 'kategorie_id',
        references: 'dokument_dokumentkategorie(id)'
      },
      {
        column: 'fachpartner_id',
        references: 'dienstleister_fachpartner(id)'
      },
      {
        column: 'lieferant_id',
        references: 'dienstleister_systempartner(id)'
      },
      {
        column: 'usp_id',
        references: 'dienstleister_umsetzungspartner(id)'
      },
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      }
    ],
    indexes: [
      {
        name: 'dokument_dokumentvorlage_8b7ae3af',
        columns: ['mandant_id'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentvorlage_55f56498',
        columns: ['is_active'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentvorlage_a07dc71a',
        columns: ['lieferant_id'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentvorlage_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentvorlage_e93cb7eb',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentvorlage_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentvorlage_d880e5da',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentvorlage_c707943f',
        columns: ['freigabe_vdl'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentvorlage_56964e0a',
        columns: ['vdl_id'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentvorlage_f62baf4c',
        columns: ['is_default'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentvorlage_cc745a5b',
        columns: ['kategorie_id'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentvorlage_00fc71c1',
        columns: ['freigabe_fachpartner'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentvor_fachpartner_id_2e5a55de_fk_dienstlei',
        columns: ['fachpartner_id'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentvor_usp_id_5a1ef1b3_fk_dienstlei',
        columns: ['usp_id'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentvorlage_freigabe_usp_603f3947',
        columns: ['freigabe_usp'],
        type: 'BTREE'
      }
    ]
  },
  dokument_dokumentvorlage_attachment_templates: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'from_dokumentvorlage_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'to_dokumentvorlage_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'from_dokumentvorlage_id',
        references: 'dokument_dokumentvorlage(id)'
      },
      {
        column: 'to_dokumentvorlage_id',
        references: 'dokument_dokumentvorlage(id)'
      }
    ],
    indexes: [
      {
        name: 'dokument_dokumentvorlage_from_dokumentvorlage_id__cabdf686_uniq',
        columns: ['from_dokumentvorlage_id', 'to_dokumentvorlage_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dokument_dokumentvor_to_dokumentvorlage_i_9bbed069_fk_dokument_',
        columns: ['to_dokumentvorlage_id'],
        type: 'BTREE'
      }
    ]
  },
  dokument_dokumentvorlage_produkttypen: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'dokumentvorlage_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'produkttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'dokumentvorlage_id',
        references: 'dokument_dokumentvorlage(id)'
      },
      {
        column: 'produkttyp_id',
        references: 'produkt_produkttyp(id)'
      }
    ],
    indexes: [
      {
        name: 'dokument_dokumentvorla_dokumentvorlage_id_2909e63d0ba5325c_uniq',
        columns: ['dokumentvorlage_id', 'produkttyp_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dokument_dokumentvorlage_produkttypen_08f329b4',
        columns: ['dokumentvorlage_id'],
        type: 'BTREE'
      },
      {
        name: 'dokument_dokumentvorlage_produkttypen_8f0909e3',
        columns: ['produkttyp_id'],
        type: 'BTREE'
      }
    ]
  },
  dynamic_dynamicblockpriceposition: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'block_business_id',
        type: 'varchar(50)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'absolute_margin',
        type: 'decimal(9,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'relative_margin',
        type: 'decimal(5,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'parameter_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_included_in_offer',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'hardware_tax_rate',
        type: 'decimal(4,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'service_tax_rate',
        type: 'decimal(4,2)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'parameter_id',
        references: 'dynamic_dynamicparameter(id)'
      }
    ],
    indexes: [
      {
        name: 'unique_parameter_per_block',
        columns: ['parameter_id', 'block_business_id'],
        type: 'UNIQUE'
      }
    ]
  },
  dynamic_dynamicblockpricepositiontemplate: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'absolute_margin',
        type: 'decimal(9,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'relative_margin',
        type: 'decimal(5,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'template_slug',
        type: 'varchar(50)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'parameter_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_included_in_offer',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'hardware_tax_rate',
        type: 'decimal(4,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'service_tax_rate',
        type: 'decimal(4,2)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'parameter_id',
        references: 'dynamic_dynamicparameter(id)'
      }
    ],
    indexes: [
      {
        name: 'unique_parameter_per_template_slug',
        columns: ['parameter_id', 'template_slug'],
        type: 'UNIQUE'
      },
      {
        name: 'dynamic_dynamicblocktemplatepriceposition_template_slug_2d63bcd0',
        columns: ['template_slug'],
        type: 'BTREE'
      }
    ]
  },
  dynamic_dynamicextracostposition: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'hardware_tax_rate',
        type: 'decimal(4,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'service_tax_rate',
        type: 'decimal(4,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'absolute_margin',
        type: 'decimal(9,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'relative_margin',
        type: 'decimal(5,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_included_in_offer',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'cost_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'parameter_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(256)',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'parameter_id',
        references: 'dynamic_dynamicparameter(id)'
      }
    ],
    indexes: [
      {
        name: 'unique_parameter_per_extra_cost',
        columns: ['parameter_id', 'cost_id'],
        type: 'UNIQUE'
      }
    ]
  },
  dynamic_dynamicextracostpositiontemplate: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'hardware_tax_rate',
        type: 'decimal(4,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'service_tax_rate',
        type: 'decimal(4,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'absolute_margin',
        type: 'decimal(9,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'relative_margin',
        type: 'decimal(5,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_included_in_offer',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'parameter_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'parameter_id',
        references: 'dynamic_dynamicparameter(id)'
      }
    ],
    indexes: [
      {
        name: 'dynamic_dynamicextra_parameter_id_b1de8345_fk_dynamic_d',
        columns: ['parameter_id'],
        type: 'BTREE'
      }
    ]
  },
  dynamic_dynamickostenelement: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vorzeichen_einpreisung',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'enthalten_in_grundpreis',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'basis_manuell',
        type: 'decimal(9,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'basis_dynamisch',
        type: 'varchar(80)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'anteil',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'perioden',
        type: 'longtext',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'inflationiert',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kostensteigerung',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dynamic_parameter_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_leasing',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_purchasing',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'mwst_satz',
        type: 'decimal(4,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'description',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'dynamic_parameter_id',
        references: 'dynamic_dynamicparameter(id)'
      }
    ],
    indexes: [
      {
        name: 'dynamic_dynamickoste_created_by_id_eb261529_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamickostenelement_created_at_5080b88d',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamickostenelement_lastmodified_at_7607d8de',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamickoste_dynamic_parameter_id_137a814f_fk_dynamic_d',
        columns: ['dynamic_parameter_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamickoste_lastmodified_by_id_09d9f497_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      }
    ]
  },
  dynamic_dynamickostenelementtemplate: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vorzeichen_einpreisung',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'enthalten_in_grundpreis',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'basis_manuell',
        type: 'decimal(9,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'basis_dynamisch',
        type: 'varchar(80)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'anteil',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'perioden',
        type: 'longtext',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'inflationiert',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kostensteigerung',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_leasing',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_purchasing',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'mwst_satz',
        type: 'decimal(4,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'parameter_template_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandantprodukttyp_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'description',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandantprodukttyp_id',
        references: 'produkt_mandantprodukttyp(id)'
      },
      {
        column: 'parameter_template_id',
        references: 'dynamic_dynamicparametertemplate(id)'
      }
    ],
    indexes: [
      {
        name: 'dynamic_dynamickoste_created_by_id_d27579a9_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamickoste_lastmodified_by_id_0a3dbad0_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamickoste_parameter_template_i_e03c8487_fk_dynamic_d',
        columns: ['parameter_template_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamickostenelementtemplate_created_at_14382d12',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamickostenelementtemplate_lastmodified_at_10b3bda1',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamickoste_mandantprodukttyp_id_6dad229a_fk_produkt_m',
        columns: ['mandantprodukttyp_id'],
        type: 'BTREE'
      }
    ]
  },
  dynamic_dynamicparameter: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertragslaufzeit',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'mwst_satz',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'inflationsrate',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kostensteigerungsrate',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'marge_absolut',
        type: 'decimal(7,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'marge_relativ',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'rabatt_absolut',
        type: 'decimal(7,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'rabatt_relativ',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'produkttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'rundung_ersparnis_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'rundung_kauf_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'rundung_pacht_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'kalkulationszinsfuss',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'arbeitspreis',
        type: 'decimal(5,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'arbeitspreis_einheit',
        type: 'varchar(10)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'preis_einheit_kauf',
        type: 'varchar(10)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'preis_einheit_laufend',
        type: 'varchar(10)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'additional_margin_absolute',
        type: 'decimal(7,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'additional_margin_relative',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      },
      {
        column: 'produkttyp_id',
        references: 'produkt_produkttyp(id)'
      },
      {
        column: 'rundung_ersparnis_id',
        references: 'core_rundung(id)'
      },
      {
        column: 'rundung_kauf_id',
        references: 'core_rundung(id)'
      },
      {
        column: 'rundung_pacht_id',
        references: 'core_rundung(id)'
      }
    ],
    indexes: [
      {
        name: 'rundung_ersparnis_id',
        columns: ['rundung_ersparnis_id'],
        type: 'UNIQUE'
      },
      {
        name: 'rundung_kauf_id',
        columns: ['rundung_kauf_id'],
        type: 'UNIQUE'
      },
      {
        name: 'rundung_pacht_id',
        columns: ['rundung_pacht_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dynamic_dynamicparam_created_by_id_eb0def1f_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamicparam_lastmodified_by_id_4a8155a1_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamicparam_mandant_id_3ca6db3d_fk_mandant_m',
        columns: ['mandant_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamicparam_produkttyp_id_44c18e77_fk_produkt_p',
        columns: ['produkttyp_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamicparameter_created_at_22bae17b',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamicparameter_lastmodified_at_a8c23676',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  dynamic_dynamicprojekt: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'parameter_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'parameter_id',
        references: 'dynamic_dynamicparameter(id)'
      },
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_id',
        columns: ['projekt_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dynamic_dynamicproje_created_by_id_9379da00_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamicproje_lastmodified_by_id_037ad804_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamicproje_parameter_id_75b4c806_fk_dynamic_d',
        columns: ['parameter_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamicprojekt_created_at_791a2781',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_dynamicprojekt_lastmodified_at_415630c2',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  dynamic_energy_data: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'status',
        type: 'varchar(12)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dynamic_project_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'dynamic_project_id',
        references: 'dynamic_dynamicprojekt(id)'
      }
    ],
    indexes: [
      {
        name: 'dynamic_project_id',
        columns: ['dynamic_project_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dynamic_energy_data_created_by_id_7d93809f_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_energy_data_lastmodified_by_id_268d47f2_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_energy_data_created_at_8299788a',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_energy_data_lastmodified_at_d43f9f53',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  dynamic_energy_data_energy: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_edited',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'power_consumption',
        type: 'decimal(10,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'max_annual_yield',
        type: 'decimal(10,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'self_power_consumption',
        type: 'decimal(10,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'self_power_consumption_share',
        type: 'decimal(10,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'self_sufficiency_percentage',
        type: 'decimal(5,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'max_annual_co2_savings',
        type: 'decimal(5,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'co2_car_journey_eq',
        type: 'decimal(10,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dynamic_energy_data_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'direct_self_power_consumption',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'energy_yield',
        type: 'decimal(10,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'max_installable_power',
        type: 'decimal(10,2)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'pv_suitability',
        type: 'varchar(10)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'roof_irradiation',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'stored_self_power_consumption',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'dynamic_energy_data_id',
        references: 'dynamic_energy_data(id)'
      }
    ],
    indexes: [
      {
        name: 'dynamic_energy_data_id',
        columns: ['dynamic_energy_data_id'],
        type: 'UNIQUE'
      },
      {
        name: 'dynamic_energy_data__created_by_id_6c50c534_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_energy_data__lastmodified_by_id_0b181e79_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_energy_data_energy_created_at_a0d2cb2f',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_energy_data_energy_lastmodified_at_96b5aae2',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  dynamic_energy_data_energy_media: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'field_name',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'file',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_edited',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'energy_data_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'energy_data_id',
        references: 'dynamic_energy_data_energy(id)'
      }
    ],
    indexes: [
      {
        name: 'dynamic_energy_data_ener_energy_data_id_field_nam_6c883cd0_uniq',
        columns: ['energy_data_id', 'field_name'],
        type: 'UNIQUE'
      },
      {
        name: 'dynamic_energy_data__created_by_id_a665cc58_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_energy_data__lastmodified_by_id_786f1796_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_energy_data_energy_media_created_at_2569e112',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'dynamic_energy_data_energy_media_lastmodified_at_70b04249',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  energiedach_edparameter: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'vertragslaufzeit',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lebensdauer',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kosten_abnahme',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'steigerung_einspeisekosten',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'inflationsrate_grundpreis',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'optimierungsgroesse_anlagenleistung',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'berechnungsart_dlp',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'wartung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'versicherungskosten',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'minimale_versicherungspraemie',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'risikoaufschlag',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'abrechnungskosten',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kundenbetreuungskosten',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'forderungsmanagement',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kosten_sonstiges',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'inflationsrate',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'einspeiseverguetung_nach_zwanzig',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'degression_einspeiseverguetung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'netzkosten_arbeitsbezogen',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'netzkosten_leistungsbezogen',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'eeg_umlage',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bagatellgrenze_eeg_umlage',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'berechnung_ust',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ust_satz_kauf',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'strompreissteigerung_bis_fuenf',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'strompreissteigerung_ab_sechs',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'steigerung_eeg_umlage',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'standard_bruttostrompreis',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'eigenkapitalanteil_kunde',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'eigenkapitalanteil_stadtwerk',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'standard_eigenkapitalverzinsung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'minimum_eigenkapitalverzinsung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'fremdkapitalzins',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'projekt_initialkosten',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'produkt_initialkosten',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'standard_eigenverbrauchsanteil',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'abregelung_leistung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'cozwei_emission',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'cozwei_emission_solarstrom',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'minimum_leistung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'leistungseinbusse',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'korrekturfaktor_leistung_speicherpaket',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'hoechstverbrauch_batteriespeicher',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'marge_relativ',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'marge_min',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'marge_max',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'eigenverbrauch_batterie',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'instandhaltung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'berechnungsart_laufende_dienstleistungskosten',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bagatellgrenze_eeg_umlage_jahresertrag',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vtkosten_zuschlag',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'reststromtarif_file',
        type: 'varchar(600)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'kaufpreis_tr1',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kaufpreis_tr2',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kaufpreis_tr3',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'rundung_ersparnis_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'rundung_kauf_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'rundung_pacht_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'toleranzgrenze_leistung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'eeg_verguetung_active',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ust_satz_pacht',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      },
      {
        column: 'rundung_ersparnis_id',
        references: 'core_rundung(id)'
      },
      {
        column: 'rundung_kauf_id',
        references: 'core_rundung(id)'
      },
      {
        column: 'rundung_pacht_id',
        references: 'core_rundung(id)'
      }
    ],
    indexes: [
      {
        name: 'rundung_ersparnis_id',
        columns: ['rundung_ersparnis_id'],
        type: 'UNIQUE'
      },
      {
        name: 'rundung_kauf_id',
        columns: ['rundung_kauf_id'],
        type: 'UNIQUE'
      },
      {
        name: 'rundung_pacht_id',
        columns: ['rundung_pacht_id'],
        type: 'UNIQUE'
      },
      {
        name: 'energiedach_edparameter_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_edparameter_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_edparameter_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_edparameter_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_edparameter_11c9e131',
        columns: ['mandant_id'],
        type: 'BTREE'
      }
    ]
  },
  energiedach_edprojekt: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'parameter_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'verbrauchsprofil',
        type: 'varchar(10)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'jahresstromverbrauch',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'strompreis',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_doppelbelegung',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dachausrichtung',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dachneigung',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'korr_anlagenleistung',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'vorgabe_jahresertrag',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'eigenverbrauchsanteil',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'inbetriebnahme_anlage',
        type: 'date',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'einspeiseverguetung_errechnet',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dachflaeche',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'eignung_pv',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'verschattung',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dachausrichtung_tetraeder',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dachneigung_tetraeder',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'reststrom_gewuenscht',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'reststrom_tariftyp',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'parameter_id',
        references: 'energiedach_edparameter(id)'
      },
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_id',
        columns: ['projekt_id'],
        type: 'UNIQUE'
      },
      {
        name: 'energiedach_edprojekt_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_edprojekt_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_edprojekt_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_edprojekt_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_edprojekt_1d1f7f60',
        columns: ['parameter_id'],
        type: 'BTREE'
      },
      {
        name: 'energiedach_projekt_b06626_idx',
        columns: ['projekt_id', 'id'],
        type: 'BTREE'
      }
    ]
  },
  energiespeicher_espeicherparameter: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertragslaufzeit',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'wartung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'instandhaltung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'eigenverbrauch_batterie',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'hoechstverbrauch_batteriespeicher',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'abrechnungskosten',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'abregelung_leistung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bagatellgrenze_eeg_umlage',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'berechnung_ust',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'berechnungsart_dlp',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'cozwei_emission',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'cozwei_emission_solarstrom',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'degression_einspeiseverguetung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'eeg_umlage',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'eigenkapitalanteil_kunde',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'eigenkapitalanteil_stadtwerk',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'einspeiseverguetung_nach_zwanzig',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'forderungsmanagement',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'fremdkapitalzins',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'inflationsrate',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'inflationsrate_grundpreis',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kosten_abnahme',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kosten_sonstiges',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kundenbetreuungskosten',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'leistungseinbusse',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'marge_max',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'marge_min',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'marge_relativ',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'minimale_versicherungspraemie',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'minimum_eigenkapitalverzinsung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'netzkosten_arbeitsbezogen',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'netzkosten_leistungsbezogen',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'produkt_initialkosten',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'projekt_initialkosten',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'risikoaufschlag',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'standard_bruttostrompreis',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'standard_eigenkapitalverzinsung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'steigerung_eeg_umlage',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'steigerung_einspeisekosten',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'strompreissteigerung_ab_sechs',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'strompreissteigerung_bis_fuenf',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'versicherungskosten',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lebensdauer',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ust_satz_kauf',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'berechnungsart_laufende_dienstleistungskosten',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'korrekturfaktor_leistung_speicherpaket',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'minimum_leistung',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'standard_eigenverbrauchsanteil',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vtkosten_zuschlag',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'reststromtarif_file',
        type: 'varchar(600)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'kaufpreis_tr1',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kaufpreis_tr2',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kaufpreis_tr3',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'rundung_ersparnis_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'rundung_kauf_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'rundung_pacht_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ust_satz_pacht',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      },
      {
        column: 'rundung_ersparnis_id',
        references: 'core_rundung(id)'
      },
      {
        column: 'rundung_kauf_id',
        references: 'core_rundung(id)'
      },
      {
        column: 'rundung_pacht_id',
        references: 'core_rundung(id)'
      }
    ],
    indexes: [
      {
        name: 'rundung_ersparnis_id',
        columns: ['rundung_ersparnis_id'],
        type: 'UNIQUE'
      },
      {
        name: 'rundung_kauf_id',
        columns: ['rundung_kauf_id'],
        type: 'UNIQUE'
      },
      {
        name: 'rundung_pacht_id',
        columns: ['rundung_pacht_id'],
        type: 'UNIQUE'
      },
      {
        name: 'energiespe_created_by_id_5d809ab21006af8_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'ener_lastmodified_by_id_4d792fb3fa0198de_fk_account_emailuser_id',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'energiespeicher_espeicherparameter_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'energiespeicher_espeicherparameter_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'energiespeicher_espeicherparameter_11c9e131',
        columns: ['mandant_id'],
        type: 'BTREE'
      }
    ]
  },
  energiespeicher_espeicherprojekt: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bestandsanlage_datum',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'bestandsanlage_leistung',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'edprojekt_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'parameter_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'parameter_id',
        references: 'energiespeicher_espeicherparameter(id)'
      },
      {
        column: 'edprojekt_id',
        references: 'energiedach_edprojekt(id)'
      },
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_id',
        columns: ['projekt_id'],
        type: 'UNIQUE'
      },
      {
        name: 'energiesp_created_by_id_2596d6c3e9ed748c_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'energi_edprojekt_id_5c728918c54089a7_fk_energiedach_edprojekt_id',
        columns: ['edprojekt_id'],
        type: 'BTREE'
      },
      {
        name: 'ener_lastmodified_by_id_577fd4e3e018b55e_fk_account_emailuser_id',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'D941e9a22dffceed414b68760472139f',
        columns: ['parameter_id'],
        type: 'BTREE'
      },
      {
        name: 'energiespeicher_espeicherprojekt_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'energiespeicher_espeicherprojekt_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'energiespei_projekt_1e59ab_idx',
        columns: ['projekt_id', 'id'],
        type: 'BTREE'
      }
    ]
  },
  feed_post: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'object_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'uid',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'type',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'text',
        type: 'longtext',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'content_type_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'data',
        type: 'json',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'answer_to_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mail_received_at',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'message_sent_at',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'subject',
        type: 'varchar(400)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'customer_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'hash',
        type: 'varchar(15)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_visible_for_fachpartner',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_visible_for_lieferant',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_visible_for_mandant',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_visible_for_vdl',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'read',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_deleted',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_visible_for_usp',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_edited',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'answer_to_id',
        references: 'feed_post(id)'
      },
      {
        column: 'customer_id',
        references: 'kunde_kunde(id)'
      }
    ],
    indexes: [
      {
        name: 'hash',
        columns: ['hash'],
        type: 'UNIQUE'
      },
      {
        name: 'feed_post_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'feed_post_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'feed_post_417f1b1c',
        columns: ['content_type_id'],
        type: 'BTREE'
      },
      {
        name: 'feed_post_e93cb7eb',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'feed_post_d880e5da',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'feed_post_b7643b45',
        columns: ['answer_to_id'],
        type: 'BTREE'
      },
      {
        name: 'feed_post_cb24373b',
        columns: ['customer_id'],
        type: 'BTREE'
      },
      {
        name: 'feed_post_object_id_63bb9601',
        columns: ['object_id'],
        type: 'BTREE'
      },
      {
        name: 'feed_post_is_deleted_f0d90d4c',
        columns: ['is_deleted'],
        type: 'BTREE'
      }
    ]
  },
  feed_postfile: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'filename',
        type: 'varchar(400)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'file',
        type: 'varchar(600)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'post_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'downloaded_at',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'post_id',
        references: 'feed_post(id)'
      }
    ],
    indexes: [
      {
        name: 'feed_postfile_f3aa1999',
        columns: ['post_id'],
        type: 'BTREE'
      }
    ]
  },
  frontend_frontendv2: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_deleted',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'link_impressum',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'link_datenschutz',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'logo',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'allowed_referrer',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'page_name',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'key',
        type: 'varchar(20)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertragsmodell_auswahl',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'text_content',
        type: 'json',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'layout',
        type: 'json',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'configuration',
        type: 'json',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandantprodukttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertriebskanal_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'datenschutzbestimmungen',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'link_nutzungsbedingungen',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'tracking',
        type: 'json',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'pqp_plz_auth',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'redirect_after_completion',
        type: 'varchar(200)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'productbundle_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'productbundle_active',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'country',
        type: 'varchar(2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'use_baukasten_features',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'plz_file',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'plz_file_lastmodified_at',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'plz_file_lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'use_block_based_vlex_calculation',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandantprodukttyp_id',
        references: 'produkt_mandantprodukttyp(id)'
      },
      {
        column: 'productbundle_id',
        references: 'produkt_produkt(id)'
      },
      {
        column: 'vertriebskanal_id',
        references: 'vertrieb_vertriebskanal(id)'
      }
    ],
    indexes: [
      {
        name: 'key',
        columns: ['key'],
        type: 'UNIQUE'
      },
      {
        name: 'frontend_frontendv2_created_by_id_5db74572_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'frontend_frontendv2_lastmodified_by_id_a9d8f440_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'frontend_frontendv2_mandantprodukttyp_id_3b462111_fk_produkt_m',
        columns: ['mandantprodukttyp_id'],
        type: 'BTREE'
      },
      {
        name: 'frontend_frontendv2_vertriebskanal_id_9cda9c27_fk_vertrieb_',
        columns: ['vertriebskanal_id'],
        type: 'BTREE'
      },
      {
        name: 'frontend_frontendv2_created_at_d042bea8',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'frontend_frontendv2_lastmodified_at_9744f3ae',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'frontend_frontendv2_is_deleted_37e3c71f',
        columns: ['is_deleted'],
        type: 'BTREE'
      },
      {
        name: 'frontend_frontendv2_productbundle_id_20b0e80d_fk_produkt_p',
        columns: ['productbundle_id'],
        type: 'BTREE'
      },
      {
        name: 'frontend_frontendv2_country_98bf8463',
        columns: ['country'],
        type: 'BTREE'
      },
      {
        name: 'frontend_frontendv2_plz_file_lastmodifie_60cae2f6_fk_account_e',
        columns: ['plz_file_lastmodified_by_id'],
        type: 'BTREE'
      }
    ]
  },
  frontend_frontendv2_verfuegbarkeit_plz: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'frontendv2_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'postleitzahl_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'frontendv2_id',
        references: 'frontend_frontendv2(id)'
      },
      {
        column: 'postleitzahl_id',
        references: 'kunde_postleitzahl(id)'
      }
    ],
    indexes: [
      {
        name: 'frontend_frontendv2_verf_frontendv2_id_postleitza_b48cbf1f_uniq',
        columns: ['frontendv2_id', 'postleitzahl_id'],
        type: 'UNIQUE'
      },
      {
        name: 'frontend_frontendv2__postleitzahl_id_5bd7dba9_fk_kunde_pos',
        columns: ['postleitzahl_id'],
        type: 'BTREE'
      }
    ]
  },
  kommunikation_kommunikationsaktion: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'aktion_art',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'erstellungsart',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'produkttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertriebskanal_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'vorlage_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_email_action',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_kundenportal_action',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'notify_kp_message_via_email',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'notify_kp_message_via_sms',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'pq_progress',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'pq_delay_days',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'abwicklung_dates',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_active',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'vorlage_id',
        references: 'dokument_dokumentvorlage(id)'
      },
      {
        column: 'produkttyp_id',
        references: 'produkt_produkttyp(id)'
      },
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      },
      {
        column: 'vertriebskanal_id',
        references: 'vertrieb_vertriebskanal(id)'
      }
    ],
    indexes: [
      {
        name: 'kommunika_created_by_id_668f70c7343a8a00_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'kommu_lastmodified_by_id_e3d9985e27d2016_fk_account_emailuser_id',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'kommunik_produkttyp_id_114b4c1e6c26eac4_fk_produkt_produkttyp_id',
        columns: ['produkttyp_id'],
        type: 'BTREE'
      },
      {
        name: 'vertriebskanal_id_c70c0a4f64b53b9_fk_vertrieb_vertriebskanal_id',
        columns: ['vertriebskanal_id'],
        type: 'BTREE'
      },
      {
        name: 'kommu_vorlage_id_26e17a68647c951d_fk_dokument_dokumentvorlage_id',
        columns: ['vorlage_id'],
        type: 'BTREE'
      },
      {
        name: 'kommunikation_kommunikationsaktion_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'kommunikation_kommunikationsaktion_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'kommunikation_kommun_mandant_id_eb7d2378_fk_mandant_m',
        columns: ['mandant_id'],
        type: 'BTREE'
      }
    ]
  },
  kommunikation_meetingreminder: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'date_offset',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'action_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'action_id',
        references: 'kommunikation_kommunikationsaktion(id)'
      }
    ],
    indexes: [
      {
        name: 'kommunikation_meetingrem_action_id_date_offset_0627e513_uniq',
        columns: ['action_id', 'date_offset'],
        type: 'UNIQUE'
      },
      {
        name: 'kommunikation_meetingreminder_created_at_43bbc1ff',
        columns: ['created_at'],
        type: 'BTREE'
      }
    ]
  },
  kunde_consent: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'consent_type',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'consent',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'text',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'person_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'created_by_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'lastmodified_by_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'person_id',
        references: 'kunde_person(id)'
      }
    ],
    indexes: [
      {
        name: 'kunde_consent_created_by_id_9da0ec79_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'kunde_consent_lastmodified_by_id_c9ea155e_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'kunde_consent_person_id_f6e55184_fk_kunde_person_id',
        columns: ['person_id'],
        type: 'BTREE'
      },
      {
        name: 'kunde_consent_created_at_1c9e12bc',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'kunde_consent_lastmodified_at_f8992655',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  kunde_kunde: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'firma',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'plz',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kundennr',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ort',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'strasse',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'hausnummer',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'anonym',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kundentyp',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'rechtsform',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'branche_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'data',
        type: 'json',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lead_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'vlink_kundennummer',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'country',
        type: 'varchar(2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_deleted',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'crm_id',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'erp_id',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'branche_id',
        references: 'kunde_branche(id)'
      },
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      }
    ],
    indexes: [
      {
        name: 'kunde_kunde_mandant_id_external_customer_nr_4c579594_uniq',
        columns: ['mandant_id', 'vlink_kundennummer'],
        type: 'UNIQUE'
      },
      {
        name: 'kunde_kunde_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'kunde_kunde_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'kunde_kunde_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'kunde_kunde_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'kunde_kunde_8b7ae3af',
        columns: ['mandant_id'],
        type: 'BTREE'
      },
      {
        name: 'kunde_kunde_e5b505d4',
        columns: ['kundentyp'],
        type: 'BTREE'
      },
      {
        name: 'kunde_kunde_df60ff50',
        columns: ['rechtsform'],
        type: 'BTREE'
      },
      {
        name: 'kunde_kunde_55111307',
        columns: ['branche_id'],
        type: 'BTREE'
      },
      {
        name: 'kunde_kunde_country_72a11aff',
        columns: ['country'],
        type: 'BTREE'
      },
      {
        name: 'kunde_kunde_is_deleted_81728123',
        columns: ['is_deleted'],
        type: 'BTREE'
      }
    ]
  },
  kunde_kunde_erreichbarkeit: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'kunde_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'erreichbarkeit_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'erreichbarkeit_id',
        references: 'kunde_erreichbarkeit(id)'
      },
      {
        column: 'kunde_id',
        references: 'kunde_kunde(id)'
      }
    ],
    indexes: [
      {
        name: 'kunde_id',
        columns: ['kunde_id', 'erreichbarkeit_id'],
        type: 'UNIQUE'
      },
      {
        name: 'ku_erreichbarkeit_id_5c217255bc600e7a_fk_kunde_erreichbarkeit_id',
        columns: ['erreichbarkeit_id'],
        type: 'BTREE'
      }
    ]
  },
  kunde_optincontactchannel: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'email',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'phone',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mobile_phone',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'newsletter',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'sms',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'letter',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'person_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'created_by_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'lastmodified_by_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'person_id',
        references: 'kunde_person(id)'
      }
    ],
    indexes: [
      {
        name: 'person_id',
        columns: ['person_id'],
        type: 'UNIQUE'
      },
      {
        name: 'kunde_optincontactch_created_by_id_7e31a09d_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'kunde_optincontactch_lastmodified_by_id_db28b2fc_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'kunde_optincontactchannel_created_at_1d645294',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'kunde_optincontactchannel_lastmodified_at_b26c481f',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  kunde_person: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'geschlecht',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'titel',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'vorname',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'nachname',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'telefon',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'email',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'kunde_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fax',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mobil',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'account_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'password_reset_attempted_at',
        type: 'datetime(6)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'abteilung',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'funktion',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'vertragspartner_geschlecht',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'vertragspartner_nachname',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertragspartner_titel',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertragspartner_vorname',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'account_id',
        references: 'account_account(id)'
      },
      {
        column: 'kunde_id',
        references: 'kunde_kunde(id)'
      }
    ],
    indexes: [
      {
        name: 'account_id',
        columns: ['account_id'],
        type: 'UNIQUE'
      },
      {
        name: 'kunde_per_created_by_id_3acfff8fc9e88e2d_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'kunde_person_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'kunde_person_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'kunde_person_c3154b9c',
        columns: ['nachname'],
        type: 'BTREE'
      },
      {
        name: 'kunde_person_e9cf1ac7',
        columns: ['kunde_id'],
        type: 'BTREE'
      },
      {
        name: 'kunde_person_d880e5da',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      }
    ]
  },
  kundenportal_kundenportalstatuskonfiguration: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_deleted',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'status',
        type: 'varchar(50)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'short_description',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'long_description',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'kundenportal_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandantprodukttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'future_description',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'kundenportal_id',
        references: 'kundenportal_kundenportal(id)'
      },
      {
        column: 'mandantprodukttyp_id',
        references: 'produkt_mandantprodukttyp(id)'
      }
    ],
    indexes: [
      {
        name: 'kundenportal_kundenp_created_by_id_07c1b3c2_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'kundenportal_kundenp_kundenportal_id_76011449_fk_kundenpor',
        columns: ['kundenportal_id'],
        type: 'BTREE'
      },
      {
        name: 'kundenportal_kundenp_lastmodified_by_id_f930f0e7_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'kundenportal_kundenp_mandantprodukttyp_id_9d91a134_fk_produkt_m',
        columns: ['mandantprodukttyp_id'],
        type: 'BTREE'
      },
      {
        name: 'kundenportal_kundenportalstatuskonfiguration_created_at_45f34f3f',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'kundenportal_kundenportalst_lastmodified_at_c4cc9c8b',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'kundenportal_kundenportalstatuskonfiguration_is_deleted_8f908741',
        columns: ['is_deleted'],
        type: 'BTREE'
      }
    ]
  },
  logistics_logistics: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ready_for_shipment',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'shipping_order_date',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_id',
        columns: ['projekt_id'],
        type: 'UNIQUE'
      },
      {
        name: 'logistics_logistics_created_by_id_dcb22a83_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'logistics_logistics_lastmodified_by_id_556a2a62_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'logistics_logistics_created_at_d933f699',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'logistics_logistics_lastmodified_at_75536228',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'logistics_logistics_ready_for_shipment_6a96e575',
        columns: ['ready_for_shipment'],
        type: 'BTREE'
      }
    ]
  },
  logistics_logisticsretoureitem: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'retoure_article_number',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'retoure_reason',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'retoure_note',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'revocation_date',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'retoure_status',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'retoure_received',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'retoure_tracking_number',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'logistics_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'logistics_id',
        references: 'logistics_logistics(id)'
      }
    ],
    indexes: [
      {
        name: 'logistics_logisticsr_created_by_id_c9c14f20_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'logistics_logisticsr_lastmodified_by_id_5db5daf6_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'logistics_logisticsr_logistics_id_bc51e4d0_fk_logistics',
        columns: ['logistics_id'],
        type: 'BTREE'
      },
      {
        name: 'logistics_logisticsretoureitem_created_at_ae731e16',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'logistics_logisticsretoureitem_lastmodified_at_aca3e27e',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  logistics_logisticsshippingitem: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'serial_number',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'shipping_date',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'tracking_number',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'logistics_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'article_number',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'logistics_id',
        references: 'logistics_logistics(id)'
      }
    ],
    indexes: [
      {
        name: 'logistics_logisticss_created_by_id_fe85e15d_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'logistics_logisticss_lastmodified_by_id_e78a2102_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'logistics_logisticss_logistics_id_4bd0c115_fk_logistics',
        columns: ['logistics_id'],
        type: 'BTREE'
      },
      {
        name: 'logistics_logisticsshippingitem_created_at_5f7cb91b',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'logistics_logisticsshippingitem_lastmodified_at_4b0762f4',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  mandant_mandant: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'slug',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'parameter_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'region_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'show_investitionskosten',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'allow_admin_access',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'allow_editing_assigned_pakete',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_demo_mandant',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'contact_email',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'notification_last_sent',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'notification_time_limit',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'default_frist_geprueft',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'default_frist_qualifikation',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'default_frist_bestellung_kunde',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'default_frist_bestellung_lieferant',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'qualification_link_email',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'anonym_in_benchmarktable',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'timeout_kundenanonymisierung',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ansprechpartner_anrede',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_geschlecht',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ansprechpartner_nachname',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_titel',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ansprechpartner_vorname',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'firma',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'hausnummer',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ort',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'plz',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'strasse',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'use_rlm',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'energiedach_primaerfarbe',
        type: 'varchar(7)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'energiedach_sekundaerfarbe',
        type: 'varchar(7)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'calculate_in_benchmark',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'show_negative_ersparnis',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'energiedach_schriftart',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'espeicherparameter_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'hash',
        type: 'varchar(10)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'abteilungsname',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'email',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'rechtsform',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'allow_auto_export',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'dir_auto_export',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'logo',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'amtsgericht',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'bank',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'bic',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fax',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'geschaeftsfuehrer',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'grussformel',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'handelsregister',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'iban',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'telefon',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'umsatzsteuer_id',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'website',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'allowed_outgoing_mail_domain',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'allow_auto_export_files',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'logo_dokument',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'allow_multiple_parametersets',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'standard_vertriebskanal_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'automatische_kundenkommunikation_aktiv',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'format_projektnamen',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'next_file_export_incremental',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'show_customer_address_in_google_maps',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'email_from',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'email_from_name',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_2fa_enforced',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_granted_vlink_next_app_api_access',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_opt_in_activated',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'font_family',
        type: 'varchar(80)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'create_activity_log_for_doc',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_granted_vlink_sales_app_api_access',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'allow_sending_bulk_emails',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_granted_vlink_buildingkit_access',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'token',
        type: 'varchar(4)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'dokumentvorlage_kundenportal_link_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_granted_rate_calculator_access',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'allow_vdl_create_kunde',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_granted_block_based_vlex_calculation_access',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'resolve_geo_coordinates',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'standard_vertriebskanal_id',
        references: 'vertrieb_vertriebskanal(id)'
      },
      {
        column: 'espeicherparameter_id',
        references: 'energiespeicher_espeicherparameter(id)'
      },
      {
        column: 'dokumentvorlage_kundenportal_link_id',
        references: 'dokument_dokumentvorlage(id)'
      },
      {
        column: 'parameter_id',
        references: 'energiedach_edparameter(id)'
      },
      {
        column: 'region_id',
        references: 'mandant_region(id)'
      }
    ],
    indexes: [
      {
        name: 'slug',
        columns: ['slug'],
        type: 'UNIQUE'
      },
      {
        name: 'token',
        columns: ['token'],
        type: 'UNIQUE'
      },
      {
        name: 'hash',
        columns: ['hash'],
        type: 'UNIQUE'
      },
      {
        name: 'mandant_manda_allowed_outgoing_mail_domian_45e974d34fcc85ad_uniq',
        columns: ['allowed_outgoing_mail_domain'],
        type: 'UNIQUE'
      },
      {
        name: 'mandant_mandant_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandant_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandant_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandant_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandant_1d1f7f60',
        columns: ['parameter_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandant_55a4ce96',
        columns: ['region_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandant_401c262d',
        columns: ['allow_admin_access'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandant_2b875e58',
        columns: ['allow_editing_assigned_pakete'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandant_7881ee66',
        columns: ['espeicherparameter_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandant_df60ff50',
        columns: ['rechtsform'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandant_3786f9a7',
        columns: ['standard_vertriebskanal_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandant_email_from_526ab079',
        columns: ['email_from'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandant_allow_sending_bulk_emails_2cc398eb',
        columns: ['allow_sending_bulk_emails'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandant_dokumentvorlage_kund_53b0c2af_fk_dokument_',
        columns: ['dokumentvorlage_kundenportal_link_id'],
        type: 'BTREE'
      }
    ]
  },
  mandant_mandant_erreichbarkeit: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'erreichbarkeit_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'erreichbarkeit_id',
        references: 'kunde_erreichbarkeit(id)'
      },
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      }
    ],
    indexes: [
      {
        name: 'mandant_mandant_erreichb_mandant_id_erreichbarkei_a192ba2d_uniq',
        columns: ['mandant_id', 'erreichbarkeit_id'],
        type: 'UNIQUE'
      },
      {
        name: 'mandant_mandant_erre_erreichbarkeit_id_914f1518_fk_kunde_err',
        columns: ['erreichbarkeit_id'],
        type: 'BTREE'
      }
    ]
  },
  mandant_mandantstaticmodel: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'color_primary',
        type: 'varchar(7)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'color_secondary',
        type: 'varchar(7)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'logo_sales',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      }
    ],
    indexes: [
      {
        name: 'mandant_id',
        columns: ['mandant_id'],
        type: 'UNIQUE'
      },
      {
        name: 'mandant_mandantstati_created_by_id_d2e11ae5_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandantstati_lastmodified_by_id_9db64eb9_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandantstaticmodel_created_at_edf98b50',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandantstaticmodel_lastmodified_at_7468126b',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  mandant_mandantumsetzungspartner: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'freigabe',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'produkttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'umsetzungspartner_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      },
      {
        column: 'produkttyp_id',
        references: 'produkt_produkttyp(id)'
      },
      {
        column: 'umsetzungspartner_id',
        references: 'dienstleister_umsetzungspartner(id)'
      }
    ],
    indexes: [
      {
        name: 'mandant_mandantumsetzung_umsetzungspartner_id_man_88cea996_uniq',
        columns: [
          'umsetzungspartner_id',
          'mandant_id',
          'produkttyp_id',
          'freigabe'
        ],
        type: 'UNIQUE'
      },
      {
        name: 'mandant_mandantumset_created_by_id_3111819c_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandantumset_lastmodified_by_id_7130ce2d_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandantumset_mandant_id_a9c41af9_fk_mandant_m',
        columns: ['mandant_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandantumset_produkttyp_id_e5129a75_fk_produkt_p',
        columns: ['produkttyp_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandantumsetzungspartner_created_at_12ac71f0',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandantumsetzungspartner_lastmodified_at_98357ef1',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  mandant_mandantumsetzungspartner_vertriebskanaele: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'mandantumsetzungspartner_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertriebskanal_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandantumsetzungspartner_id',
        references: 'mandant_mandantumsetzungspartner(id)'
      },
      {
        column: 'vertriebskanal_id',
        references: 'vertrieb_vertriebskanal(id)'
      }
    ],
    indexes: [
      {
        name: 'mandant_mandantumsetzung_mandantumsetzungspartner_77d1bca9_uniq',
        columns: ['mandantumsetzungspartner_id', 'vertriebskanal_id'],
        type: 'UNIQUE'
      },
      {
        name: 'mandant_mandantumset_vertriebskanal_id_5c30943d_fk_vertrieb_',
        columns: ['vertriebskanal_id'],
        type: 'BTREE'
      }
    ]
  },
  mandant_mandantvertriebsdienstleister: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertriebsdienstleister_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'freigabe',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'produkttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'can_create_projects',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'vertriebsdienstleister_id',
        references: 'dienstleister_vertriebsdienstleister(id)'
      },
      {
        column: 'produkttyp_id',
        references: 'produkt_produkttyp(id)'
      },
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      }
    ],
    indexes: [
      {
        name: 'mandant_mandantv_vertriebsdienstleister_id_4e7aa2bd4540a91b_uniq',
        columns: [
          'vertriebsdienstleister_id',
          'mandant_id',
          'produkttyp_id',
          'freigabe'
        ],
        type: 'UNIQUE'
      },
      {
        name: 'mandant_ma_created_by_id_2c4a5be56742d85_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'mand_lastmodified_by_id_6e9ece53cf25a465_fk_account_emailuser_id',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandantvertriebsdienstleister_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandantvertriebsdienstleister_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandantvertriebsdienstleister_11c9e131',
        columns: ['mandant_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandantvertriebsdienstleister_9ba46b7d',
        columns: ['vertriebsdienstleister_id'],
        type: 'BTREE'
      },
      {
        name: 'mandant_mandantvertriebsdienstleister_5f3bdd18',
        columns: ['produkttyp_id'],
        type: 'BTREE'
      }
    ]
  },
  mandant_mandantvertriebsdienstleister_vertriebskanaele: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'mandantvertriebsdienstleister_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertriebskanal_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'vertriebskanal_id',
        references: 'vertrieb_vertriebskanal(id)'
      },
      {
        column: 'mandantvertriebsdienstleister_id',
        references: 'mandant_mandantvertriebsdienstleister(id)'
      }
    ],
    indexes: [
      {
        name: 'mandantvertriebsdienstleister_id',
        columns: ['mandantvertriebsdienstleister_id', 'vertriebskanal_id'],
        type: 'UNIQUE'
      },
      {
        name: 'D19878747b6272e39a9f216cdee06ce7',
        columns: ['vertriebskanal_id'],
        type: 'BTREE'
      }
    ]
  },
  notification_notification: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'read_at',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'notified_at',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'important',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'activity_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'recipient_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'text',
        type: 'varchar(256)',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'recipient_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'activity_id',
        references: 'actstream_action(id)'
      }
    ],
    indexes: [
      {
        name: 'notification_compound_idx',
        columns: ['recipient_id', 'read_at', 'important'],
        type: 'BTREE'
      },
      {
        name: 'notification_notification_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'notification_notification_48818f3d',
        columns: ['important'],
        type: 'BTREE'
      },
      {
        name: 'notification_notification_f8a3193a',
        columns: ['activity_id'],
        type: 'BTREE'
      },
      {
        name: 'notification_notification_8b938c66',
        columns: ['recipient_id'],
        type: 'BTREE'
      }
    ]
  },
  paket_mandantpaket: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'paket_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      },
      {
        column: 'paket_id',
        references: 'paket_paket(id)'
      }
    ],
    indexes: [
      {
        name: 'paket_mandantpaket_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'paket_mandantpaket_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'paket_mandantpaket_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'paket_mandantpaket_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'paket_mandantpaket_079621e3',
        columns: ['paket_id'],
        type: 'BTREE'
      },
      {
        name: 'paket_mandantpaket_8b7ae3af',
        columns: ['mandant_id'],
        type: 'BTREE'
      }
    ]
  },
  produkt_mandantprodukt: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'produkt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mindestvertriebsprovision',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'relative_vertriebsprovision',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'allow_paket_project_creation',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      },
      {
        column: 'produkt_id',
        references: 'produkt_produkt(id)'
      }
    ],
    indexes: [
      {
        name: 'produkt_mandantprodukt_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodukt_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodukt_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodukt_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodukt_4a0f543a',
        columns: ['produkt_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodukt_8b7ae3af',
        columns: ['mandant_id'],
        type: 'BTREE'
      }
    ]
  },
  produkt_mandantprodukttyp: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'produkttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'kaufoption_aktiv',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'email_from',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'email_from_name',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'create_lieferant_manuell',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'email',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'slug',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'email_signature',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'vlink_mail',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'can_send_email',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'automatische_kundenkommunikation_aktiv',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'reststrom_aktiv',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'email_portal_benutzer',
        type: 'varchar(254)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'dynamic_parameter_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'custom_offer_status_modal_text',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'custom_offer_status_name',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'custom_offer_status_tag_name',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'status_offer_skipped',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'afm_beauftragt_default',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'produkt_verfuegbarkeit_aktiv',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'allow_logistics',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'default_reserved_order',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'dokumentvorlage_qualifikation_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'skip_confirmation_mail',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertragsmodell_default',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'use_block_based_vlex_calculation_default',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'energy_data_available',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      },
      {
        column: 'dokumentvorlage_qualifikation_id',
        references: 'dokument_dokumentvorlage(id)'
      },
      {
        column: 'dynamic_parameter_id',
        references: 'dynamic_dynamicparameter(id)'
      },
      {
        column: 'produkttyp_id',
        references: 'produkt_produkttyp(id)'
      }
    ],
    indexes: [
      {
        name: 'produkt_mandantprodukttyp_mandant_id_produkttyp_id_e1557f7b_uniq',
        columns: ['mandant_id', 'produkttyp_id'],
        type: 'UNIQUE'
      },
      {
        name: 'produkt_mandantprodukttyp_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodukttyp_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodukttyp_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodukttyp_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodukttyp_8f0909e3',
        columns: ['produkttyp_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodukttyp_8b7ae3af',
        columns: ['mandant_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodukttyp_2dbcba41',
        columns: ['slug'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodu_dynamic_parameter_id_7e5a0c04_fk_dynamic_d',
        columns: ['dynamic_parameter_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodukttyp_email_from_31313d13',
        columns: ['email_from'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodukttyp_allow_logistics_d5c9d78a',
        columns: ['allow_logistics'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodu_dokumentvorlage_qual_e51182f8_fk_dokument_',
        columns: ['dokumentvorlage_qualifikation_id'],
        type: 'BTREE'
      }
    ]
  },
  produkt_mandantprodukttyp_email_forward_to: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'mandantprodukttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'emailuser_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandantprodukttyp_id',
        references: 'produkt_mandantprodukttyp(id)'
      },
      {
        column: 'emailuser_id',
        references: 'account_emailuser(id)'
      }
    ],
    indexes: [
      {
        name: 'mandantprodukttyp_id',
        columns: ['mandantprodukttyp_id', 'emailuser_id'],
        type: 'UNIQUE'
      },
      {
        name: 'produkt_mandantprodukttyp_email_forward_to_5afcd27c',
        columns: ['mandantprodukttyp_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodukttyp_email_forward_to_eb9384ff',
        columns: ['emailuser_id'],
        type: 'BTREE'
      }
    ]
  },
  produkt_mandantprodukttyp_users_to_notify_on_projekt_created: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'mandantprodukttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'emailuser_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandantprodukttyp_id',
        references: 'produkt_mandantprodukttyp(id)'
      },
      {
        column: 'emailuser_id',
        references: 'account_emailuser(id)'
      }
    ],
    indexes: [
      {
        name: 'mandantprodukttyp_id',
        columns: ['mandantprodukttyp_id', 'emailuser_id'],
        type: 'UNIQUE'
      },
      {
        name: 'produkt_mandantprodukttyp_users_to_notify_on_projekt_created374b',
        columns: ['mandantprodukttyp_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_mandantprodukttyp_users_to_notify_on_projekt_created369d',
        columns: ['emailuser_id'],
        type: 'BTREE'
      }
    ]
  },
  produkt_produktvariante: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'slug',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandantprodukttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandantprodukttyp_id',
        references: 'produkt_mandantprodukttyp(id)'
      }
    ],
    indexes: [
      {
        name: 'produkt_produktvariante_mandantprodukttyp_id_slug_6dfd7a45_uniq',
        columns: ['mandantprodukttyp_id', 'slug'],
        type: 'UNIQUE'
      },
      {
        name: 'produkt_produktvaria_created_by_id_d4bb8504_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produktvaria_lastmodified_by_id_fedab442_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produktvariante_created_at_cfbc61af',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produktvariante_lastmodified_at_01fcb7af',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produktvariante_slug_21f86dd6',
        columns: ['slug'],
        type: 'BTREE'
      }
    ]
  },
  produkt_produktvarianteadresse: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'plz',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'ort',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'strasse',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'hausnummer',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandantprodukttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'mandantprodukttyp_id',
        references: 'produkt_mandantprodukttyp(id)'
      }
    ],
    indexes: [
      {
        name: 'produkt_produktvaria_created_by_id_c9902838_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produktvaria_lastmodified_by_id_d1bdb596_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produktvaria_mandantprodukttyp_id_0d164fa0_fk_produkt_m',
        columns: ['mandantprodukttyp_id'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produktvarianteadresse_created_at_0f006cde',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produktvarianteadresse_lastmodified_at_1a24a24c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produktvarianteadresse_plz_aa85cfe9',
        columns: ['plz'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produktvarianteadresse_ort_818f7ca6',
        columns: ['ort'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produktvarianteadresse_strasse_ca281a42',
        columns: ['strasse'],
        type: 'BTREE'
      },
      {
        name: 'produkt_produktvarianteadresse_hausnummer_46e83348',
        columns: ['hausnummer'],
        type: 'BTREE'
      },
      {
        name: 'produkt_pro_strasse_05c637_idx',
        columns: ['strasse', 'hausnummer'],
        type: 'BTREE'
      },
      {
        name: 'produkt_pro_ort_a89aa9_idx',
        columns: ['ort', 'strasse'],
        type: 'BTREE'
      },
      {
        name: 'produkt_pro_plz_6a51ca_idx',
        columns: ['plz', 'strasse'],
        type: 'BTREE'
      }
    ]
  },
  produkt_produktvarianteadresse_produkt_varianten: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'produktvarianteadresse_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'produktvariante_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'produktvariante_id',
        references: 'produkt_produktvariante(id)'
      },
      {
        column: 'produktvarianteadresse_id',
        references: 'produkt_produktvarianteadresse(id)'
      }
    ],
    indexes: [
      {
        name: 'produkt_produktvariantea_produktvarianteadresse_i_7515d4a3_uniq',
        columns: ['produktvarianteadresse_id', 'produktvariante_id'],
        type: 'UNIQUE'
      },
      {
        name: 'produkt_produktvaria_produktvariante_id_c8a370c1_fk_produkt_p',
        columns: ['produktvariante_id'],
        type: 'BTREE'
      }
    ]
  },
  projekt_intern_tags: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'fachpartner_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lieferant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'tag_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'usp_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'vdl_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'tag_id',
        references: 'tags_intern_tag(id)'
      },
      {
        column: 'fachpartner_id',
        references: 'dienstleister_fachpartner(id)'
      },
      {
        column: 'lieferant_id',
        references: 'dienstleister_systempartner(id)'
      },
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      },
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      },
      {
        column: 'usp_id',
        references: 'dienstleister_umsetzungspartner(id)'
      },
      {
        column: 'vdl_id',
        references: 'dienstleister_vertriebsdienstleister(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_private_tags_fachpartner_id_72ee839b_fk_dienstlei',
        columns: ['fachpartner_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_private_tags_lieferant_id_a9dd34a5_fk_dienstlei',
        columns: ['lieferant_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_private_tags_mandant_id_5ff848c9_fk_mandant_mandant_id',
        columns: ['mandant_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_private_tags_projekt_id_cc9c1b15_fk_projekt_projekt_id',
        columns: ['projekt_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_private_tags_usp_id_09fd8f82_fk_dienstlei',
        columns: ['usp_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_private_tags_vdl_id_8cda79f9_fk_dienstlei',
        columns: ['vdl_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_intern_tags_tag_id_0f8173ec_fk_tags_private_tag_id',
        columns: ['tag_id'],
        type: 'BTREE'
      }
    ]
  },
  projekt_projekt: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'projektnr',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'name',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'produkt_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'paket_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lieferant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'ist_trianel_zugewiesen',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'status',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertriebsprovision',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'token',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'token_email_ist_versendet',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertragsmodell',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'absagegrund_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'paket_manuell_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'paket_individuell_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'paket_optimiert_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'bearbeiter_lieferant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'bearbeiter_mandant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'bearbeiter_platform_manager_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'altes_projekt',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'migriertes_projekt',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'investitionssumme_calculated',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'leistung_calculated',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'paket_calculated_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'qualifikation_fortschritt',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'last_action_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'bearbeiter_vdl_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'vdl_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'erstellungsart',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertriebskanal_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'email_vertrieb',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'bearbeiter_fachpartner_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fachpartner_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fachpartner_auswertung_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'vdl_auswertung_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'kopie_von_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'automatische_kundenkommunikation_aktiv',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'device_type',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'instadr_geschlecht',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'instadr_mobil',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'instadr_nachname',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'instadr_ort',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'instadr_plz',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'instadr_strasse',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'instadr_telefon',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'instadr_titel',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'instadr_vorname',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'instadr_hausnr',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'crossdomain_id',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'berechnung_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'frontend_v2_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'tags_string',
        type: 'longtext',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'show_duplicated_kunde_message',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'country',
        type: 'varchar(2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'person_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'use_baukasten_features',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'building_kit_fixed_data',
        type: 'json',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'usp_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'bearbeiter_usp_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'instadr_firma',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'use_block_based_vlex_calculation',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'location_latitude',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'location_longitude',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'intermediate_status',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'vdl_id',
        references: 'dienstleister_vertriebsdienstleister(id)'
      },
      {
        column: 'bearbeiter_lieferant_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'vdl_auswertung_id',
        references: 'dienstleister_vertriebsdienstleister(id)'
      },
      {
        column: 'bearbeiter_fachpartner_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      },
      {
        column: 'bearbeiter_mandant_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'produkt_id',
        references: 'produkt_produkt(id)'
      },
      {
        column: 'bearbeiter_vdl_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'absagegrund_id',
        references: 'projekt_absagegrund(id)'
      },
      {
        column: 'paket_individuell_id',
        references: 'paket_paket(id)'
      },
      {
        column: 'last_action_id',
        references: 'actstream_action(id)'
      },
      {
        column: 'paket_calculated_id',
        references: 'paket_paket(id)'
      },
      {
        column: 'paket_optimiert_id',
        references: 'paket_paket(id)'
      },
      {
        column: 'paket_manuell_id',
        references: 'paket_paket(id)'
      },
      {
        column: 'bearbeiter_platform_manager_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'bearbeiter_usp_id',
        references: 'account_emailuser(id)'
      },
      {
        column: 'berechnung_id',
        references: 'projekt_berechnung(id)'
      },
      {
        column: 'fachpartner_auswertung_id',
        references: 'dienstleister_fachpartner(id)'
      },
      {
        column: 'fachpartner_id',
        references: 'dienstleister_fachpartner(id)'
      },
      {
        column: 'frontend_v2_id',
        references: 'frontend_frontendv2(id)'
      },
      {
        column: 'kopie_von_id',
        references: 'projekt_projekt(id)'
      },
      {
        column: 'lieferant_id',
        references: 'dienstleister_systempartner(id)'
      },
      {
        column: 'paket_id',
        references: 'paket_paket(id)'
      },
      {
        column: 'person_id',
        references: 'kunde_person(id)'
      },
      {
        column: 'usp_id',
        references: 'dienstleister_umsetzungspartner(id)'
      },
      {
        column: 'vertriebskanal_id',
        references: 'vertrieb_vertriebskanal(id)'
      }
    ],
    indexes: [
      {
        name: 'berechnung_id',
        columns: ['berechnung_id'],
        type: 'UNIQUE'
      },
      {
        name: 'projekt_projekt_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_4a0f543a',
        columns: ['produkt_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_079621e3',
        columns: ['paket_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_c9e90e4e',
        columns: ['lieferant_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_8b7ae3af',
        columns: ['mandant_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_48fb58bb',
        columns: ['status'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_ca0017c9',
        columns: ['paket_manuell_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_42a1193c',
        columns: ['paket_individuell_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_3bbb5d3d',
        columns: ['paket_optimiert_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_31b46ccf',
        columns: ['bearbeiter_lieferant_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_564dd075',
        columns: ['bearbeiter_mandant_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_32599721',
        columns: ['bearbeiter_platform_manager_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_name_2863169c7d45a742_uniq',
        columns: ['name'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_projektnr_444cf46987727ed1_uniq',
        columns: ['projektnr'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_7042d802',
        columns: ['paket_calculated_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_ae6af57f',
        columns: ['last_action_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_0d2cc3c9',
        columns: ['bearbeiter_vdl_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_56964e0a',
        columns: ['vdl_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_001eea29',
        columns: ['vertriebskanal_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_absagegrund_id_4923beb187a2364a_uniq',
        columns: ['absagegrund_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_b25b3463',
        columns: ['bearbeiter_fachpartner_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_fabb6a95',
        columns: ['fachpartner_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_7ed6f2ca',
        columns: ['fachpartner_auswertung_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_06c09185',
        columns: ['vdl_auswertung_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_2f6b647e',
        columns: ['kopie_von_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_frontend_v2_id_24eeaea5_fk_frontend_',
        columns: ['frontend_v2_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_country_da9caebe',
        columns: ['country'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_person_id_d83c3c9a_fk_kunde_person_id',
        columns: ['person_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_usp_id_6547166f_fk_dienstlei',
        columns: ['usp_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_bearbeiter_usp_id_ee825a77_fk_account_e',
        columns: ['bearbeiter_usp_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_token_1140e1d4',
        columns: ['token'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_intermediate_status_a05dc87c',
        columns: ['intermediate_status'],
        type: 'BTREE'
      }
    ]
  },
  projekt_projekt_kunden: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kunde_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      },
      {
        column: 'kunde_id',
        references: 'kunde_kunde(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_projekt_kunden_projekt_id_66a280178ae345fd_uniq',
        columns: ['projekt_id', 'kunde_id'],
        type: 'UNIQUE'
      },
      {
        name: 'projekt_projekt_kunden_83dd1862',
        columns: ['projekt_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projekt_kunden_ac7e9b85',
        columns: ['kunde_id'],
        type: 'BTREE'
      }
    ]
  },
  projekt_projekt_tags: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'tag_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      },
      {
        column: 'tag_id',
        references: 'tags_tag(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_projekt_tags_projekt_id_tag_id_2fb4cdcf_uniq',
        columns: ['projekt_id', 'tag_id'],
        type: 'UNIQUE'
      },
      {
        name: 'projekt_projekt_tags_tag_id_0ed91971_fk_tags_tag_id',
        columns: ['tag_id'],
        type: 'BTREE'
      }
    ]
  },
  projekt_projektkommunikationsaktion: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'aktion_art',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'reminder_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      },
      {
        column: 'reminder_id',
        references: 'kommunikation_meetingreminder(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_projektkommunikationsaktion_created_at_b6b400d5',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektkommunikationsaktion_aktion_art_65657d65',
        columns: ['aktion_art'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektkommunikationsaktion_projekt_id_5adba679',
        columns: ['projekt_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektkommu_reminder_id_139d5dce_fk_kommunika',
        columns: ['reminder_id'],
        type: 'BTREE'
      }
    ]
  },
  projekt_projektnotiz: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'note',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fachpartner_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lieferant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vdl_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'usp_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'fachpartner_id',
        references: 'dienstleister_fachpartner(id)'
      },
      {
        column: 'lieferant_id',
        references: 'dienstleister_systempartner(id)'
      },
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      },
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      },
      {
        column: 'usp_id',
        references: 'dienstleister_umsetzungspartner(id)'
      },
      {
        column: 'vdl_id',
        references: 'dienstleister_vertriebsdienstleister(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_projektnotiz_mandant_id_2214b30b_fk_mandant_mandant_id',
        columns: ['mandant_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektnotiz_projekt_id_1385d474_fk_projekt_projekt_id',
        columns: ['projekt_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektnotiz_vdl_id_2ab05ea4_fk_dienstlei',
        columns: ['vdl_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektnotiz_lieferant_id_7246c18e_fk_dienstlei',
        columns: ['lieferant_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektnotiz_fachpartner_id_b026a7cc_fk_dienstlei',
        columns: ['fachpartner_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektnotiz_usp_id_b9647fe1_fk_dienstlei',
        columns: ['usp_id'],
        type: 'BTREE'
      }
    ]
  },
  projekt_projektwiedervorlage: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'deadline',
        type: 'datetime',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lieferant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'alert_done',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vdl_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'fachpartner_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'usp_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'fachpartner_id',
        references: 'dienstleister_fachpartner(id)'
      },
      {
        column: 'lieferant_id',
        references: 'dienstleister_systempartner(id)'
      },
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      },
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      },
      {
        column: 'usp_id',
        references: 'dienstleister_umsetzungspartner(id)'
      },
      {
        column: 'vdl_id',
        references: 'dienstleister_vertriebsdienstleister(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_projektwiedervorlage_a07dc71a',
        columns: ['lieferant_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektwiedervorlage_11c9e131',
        columns: ['mandant_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektwiedervorlage_f8111fd1',
        columns: ['projekt_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektwiedervorlage_56964e0a',
        columns: ['vdl_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektwiedervorlage_fabb6a95',
        columns: ['fachpartner_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektwiede_usp_id_c6ed651e_fk_dienstlei',
        columns: ['usp_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektwiedervorlage_alert_done_0ffd3d69',
        columns: ['alert_done'],
        type: 'BTREE'
      }
    ]
  },
  projekt_sharedprojektnotizen: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'shared_mandant_vdl_note',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'shared_sp_fp_note',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_id',
        columns: ['projekt_id'],
        type: 'UNIQUE'
      }
    ]
  },
  qualifikation_bedingung: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'object_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'typ',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'operator',
        type: 'varchar(20)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'value_float',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'value_date',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'content_type_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'projektqualifikationsparameter_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'value_choice_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'produkt_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'value_choice_id',
        references: 'qualifikation_projektqualifikationsparameterchoice(id)'
      },
      {
        column: 'projektqualifikationsparameter_id',
        references: 'qualifikation_projektqualifikationsparameter(id)'
      },
      {
        column: 'produkt_id',
        references: 'produkt_produkt(id)'
      }
    ],
    indexes: [
      {
        name: 'quali_content_type_id_247e2b6623f875ec_fk_django_content_type_id',
        columns: ['content_type_id'],
        type: 'BTREE'
      },
      {
        name: 'D0aab358f1d5f95aa4d146fabab97255',
        columns: ['projektqualifikationsparameter_id'],
        type: 'BTREE'
      },
      {
        name: 'D5006c1940747ecabe482489700f0c36',
        columns: ['value_choice_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_bedingung_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_bedingung_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'qualifika_created_by_id_2d8e8676cc6d1b08_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qual_lastmodified_by_id_2314844a580e15ee_fk_account_emailuser_id',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_bedingung_4950217f',
        columns: ['produkt_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_bedingung_object_id_b0fdc46d',
        columns: ['object_id'],
        type: 'BTREE'
      }
    ]
  },
  qualifikation_buildingblockcondition: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'block_placeholder_slug',
        type: 'varchar(50)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bundle_filter_operator',
        type: 'varchar(20)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bundle_filter_value',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bundle_filter_value_type',
        type: 'varchar(7)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_including',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'pqp_bedingung_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'pqp_bedingung_id',
        references: 'qualifikation_pqpbasebedingung(id)'
      }
    ],
    indexes: [
      {
        name: 'pqp_bedingung_id',
        columns: ['pqp_bedingung_id'],
        type: 'UNIQUE'
      },
      {
        name: 'qualifikation_buildi_created_by_id_c8eabf5c_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_buildi_lastmodified_by_id_760464e3_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_buildingblockcondition_created_at_82ccbb78',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_buildingblockcondition_lastmodified_at_51045cc7',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_buildingblock_block_placeholder_slug_19562825',
        columns: ['block_placeholder_slug'],
        type: 'BTREE'
      }
    ]
  },
  qualifikation_buildingkitcondition: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'block_placeholder_slug',
        type: 'varchar(50)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bundle_filter_operator',
        type: 'varchar(20)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bundle_filter_value',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bundle_filter_value_type',
        type: 'varchar(7)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'pqp_bedingung_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'use_total_field_value',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'pqp_bedingung_id',
        references: 'qualifikation_pqpbasebedingung(id)'
      }
    ],
    indexes: [
      {
        name: 'pqp_bedingung_id',
        columns: ['pqp_bedingung_id'],
        type: 'UNIQUE'
      },
      {
        name: 'qualifikation_buildi_created_by_id_29c1fef2_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_buildi_lastmodified_by_id_02023ffe_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_buildingkitcondition_created_at_272681cf',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_buildingkitcondition_lastmodified_at_9f7021f9',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_buildingkitco_block_placeholder_slug_669c4428',
        columns: ['block_placeholder_slug'],
        type: 'BTREE'
      }
    ]
  },
  qualifikation_optionbedingung: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'option_filter_ids',
        type: 'longtext',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'pqp_bedingung_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'pqp_bedingung_id',
        references: 'qualifikation_pqpbasebedingung(id)'
      }
    ],
    indexes: [
      {
        name: 'pqp_bedingung_id',
        columns: ['pqp_bedingung_id'],
        type: 'UNIQUE'
      },
      {
        name: 'qualifikation_option_created_by_id_c0db454a_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_option_lastmodified_by_id_16b216f5_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_optionbedingung_created_at_13b4556f',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_optionbedingung_lastmodified_at_7f8d5037',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  qualifikation_paketbedingung: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bundle_filter_id',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bundle_filter_operator',
        type: 'varchar(20)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bundle_filter_value',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bundle_filter_is_freefield',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'bundle_filter_freefield_type',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'pqp_bedingung_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'pqp_bedingung_id',
        references: 'qualifikation_pqpbasebedingung(id)'
      }
    ],
    indexes: [
      {
        name: 'pqp_bedingung_id',
        columns: ['pqp_bedingung_id'],
        type: 'UNIQUE'
      },
      {
        name: 'qualifikation_paketb_created_by_id_1eaeda73_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_paketb_lastmodified_by_id_e7ef4e61_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_paketbedingung_created_at_74b565ec',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_paketbedingung_lastmodified_at_8e7d47a2',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  qualifikation_pqpbasebedingung: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'pqp_operator',
        type: 'varchar(20)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'pqp_value',
        type: 'varchar(255)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'pqp_value_choice_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'projektqualifikationsparameter_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'pqp_value_choice_id',
        references: 'qualifikation_projektqualifikationsparameterchoice(id)'
      },
      {
        column: 'projektqualifikationsparameter_id',
        references: 'qualifikation_projektqualifikationsparameter(id)'
      }
    ],
    indexes: [
      {
        name: 'qualifikation_pqpbas_pqp_value_choice_id_4e4efa24_fk_qualifika',
        columns: ['pqp_value_choice_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_pqpbas_created_by_id_353ca0e3_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_pqpbas_lastmodified_by_id_d014e3f2_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_pqpbas_projektqualifikation_9f137e3d_fk_qualifika',
        columns: ['projektqualifikationsparameter_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_pqpbasebedingung_created_at_581557a9',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_pqpbasebedingung_lastmodified_at_6123c21b',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  qualifikation_projektqualifikationsparameter: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'title',
        type: 'longtext',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'help_text',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'example_file',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'show_in_frontend',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_eingangs_qp',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'required_field',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'display_style',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'required',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_deleted',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'frontend_slider_increment',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'max_value',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'min_value',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandantprodukttyp_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'basis_pqp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'page',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'position',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'default_value',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'thousands_separator',
        type: 'tinyint(1)',
        nullable: false,
        default: '1',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'basis_pqp_id',
        references: 'qualifikation_basisprojektqualifikationsparameter(id)'
      },
      {
        column: 'mandantprodukttyp_id',
        references: 'produkt_mandantprodukttyp(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_projektqualifikationsparameter_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektqualifikationsparameter_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektqualifikationsparameter_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektqualifikationsparameter_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektqualifikationsparameter_e9b525c7',
        columns: ['show_in_frontend'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektqualifikationsparameter_1c4b328f',
        columns: ['required_field'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_projektqualifikationsparameter_2cd5ac2f',
        columns: ['display_style'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_projektqualifikationsparameter_is_deleted_60b92860',
        columns: ['is_deleted'],
        type: 'BTREE'
      },
      {
        name: 'qualifikati_positio_59331f_idx',
        columns: ['position', 'page'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_projek_mandantprodukttyp_id_989bfe50_fk_produkt_m',
        columns: ['mandantprodukttyp_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_projektqualifikationsparameter_page_8005833c',
        columns: ['page'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_projektqualifikationsparameter_position_531da4f0',
        columns: ['position'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_projek_basis_pqp_id_1bc96bf1_fk_qualifika',
        columns: ['basis_pqp_id'],
        type: 'BTREE'
      }
    ]
  },
  qualifikation_projektqualifikationsparameterchoice: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'image',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'title',
        type: 'varchar(400)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'parameter_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'parameter_id',
        references: 'qualifikation_projektqualifikationsparameter(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_projektqualifikationsparameterchoice_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektqualifikationsparameterchoice_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektqualifikationsparameterchoice_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektqualifikationsparameterchoice_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektqualifikationsparameterchoice_80740216',
        columns: ['parameter_id'],
        type: 'BTREE'
      }
    ]
  },
  qualifikation_projektqualifikationswert: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'parameter_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'value_text',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'file',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'value_choice_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'value_date',
        type: 'date',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'value_float',
        type: 'double',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_deleted',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'value_integer',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'value_choice_id',
        references: 'qualifikation_projektqualifikationsparameterchoice(id)'
      },
      {
        column: 'parameter_id',
        references: 'qualifikation_projektqualifikationsparameter(id)'
      },
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_projektqualifikationswert_96511a37',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektqualifikationswert_0c98d849',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektqualifikationswert_477a251c',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektqualifikationswert_4803b4cd',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektqualifikationswert_1d1f7f60',
        columns: ['parameter_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektqualifikationswert_83dd1862',
        columns: ['projekt_id'],
        type: 'BTREE'
      },
      {
        name: 'projekt_projektqualifikationswert_a57b5718',
        columns: ['value_choice_id'],
        type: 'BTREE'
      },
      {
        name: 'qualifikation_projektqualifikationswert_is_deleted_d3013ed9',
        columns: ['is_deleted'],
        type: 'BTREE'
      }
    ]
  },
  qualifikation_projektqualifikationswert_value_multiplechoices: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'projektqualifikationswert_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'projektqualifikationsparameterchoice_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'projektqualifikationswert_id',
        references: 'qualifikation_projektqualifikationswert(id)'
      },
      {
        column: 'projektqualifikationsparameterchoice_id',
        references: 'qualifikation_projektqualifikationsparameterchoice(id)'
      }
    ],
    indexes: [
      {
        name: 'projektqualifikationswert_id',
        columns: [
          'projektqualifikationswert_id',
          'projektqualifikationsparameterchoice_id'
        ],
        type: 'UNIQUE'
      },
      {
        name: 'D8a630dd01b721f6d770083922a0d049',
        columns: ['projektqualifikationsparameterchoice_id'],
        type: 'BTREE'
      }
    ]
  },
  reststrom_reststrom: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'angebot_erhalten',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'angebot_angenommen',
        type: 'tinyint(1)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'unterschr_vertrag',
        type: 'varchar(600)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'reststrombedarf',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'dict_reststrom',
        type: 'json',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      }
    ],
    indexes: [
      {
        name: 'projekt_id',
        columns: ['projekt_id'],
        type: 'UNIQUE'
      },
      {
        name: 'reststrom_created_by_id_4da14c24f3282a0a_fk_account_emailuser_id',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'rest_lastmodified_by_id_15161ea97441840c_fk_account_emailuser_id',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'reststrom_reststrom_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'reststrom_reststrom_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      }
    ]
  },
  reststrom_reststromkonfiguration: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'tariftyp',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'frontend_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'reststrom_default',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'frontend_id',
        references: 'frontend_frontendv2(id)'
      }
    ],
    indexes: [
      {
        name: 'frontend_id',
        columns: ['frontend_id'],
        type: 'UNIQUE'
      }
    ]
  },
  reststrom_reststromtarif: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'arbeitspreis_kwh_netto',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'flatratepreis_jahr_netto',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'grundpreis_jahr_netto',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kuendigungsfrist_wochen',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'mindestvertragslaufz_monate',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'neukundenbonus_netto',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'plz',
        type: 'varchar(50)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'preisgarantie_monate',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'sofortbonus_netto',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'tarifbezeichnung',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'tarifschluessel',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'tariftyp',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'toleranz_flat_prozent',
        type: 'double',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'verbrauch_kwh_max',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'verbrauch_kwh_min',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertragsverlaengerung_monate',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'espeicherparameter_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'parameter_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'espeicherparameter_id',
        references: 'energiespeicher_espeicherparameter(id)'
      },
      {
        column: 'parameter_id',
        references: 'energiedach_edparameter(id)'
      }
    ],
    indexes: [
      {
        name: 'D90fd61a1eb32cbe2d716d3c15269429',
        columns: ['espeicherparameter_id'],
        type: 'BTREE'
      },
      {
        name: 'rest_parameter_id_75b0c86ce7b589c1_fk_energiedach_edparameter_id',
        columns: ['parameter_id'],
        type: 'BTREE'
      }
    ]
  },
  reversion_revision: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'date_created',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'comment',
        type: 'longtext',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'user_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'user_id',
        references: 'account_emailuser(id)'
      }
    ],
    indexes: [
      {
        name: 'reversion_revision_user_id_17095f45_fk_account_emailuser_id',
        columns: ['user_id'],
        type: 'BTREE'
      },
      {
        name: 'reversion_revision_date_created_96f7c20c',
        columns: ['date_created'],
        type: 'BTREE'
      }
    ]
  },
  reversion_version: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'object_id',
        type: 'varchar(191)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'format',
        type: 'varchar(255)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'serialized_data',
        type: 'longtext',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'object_repr',
        type: 'longtext',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'content_type_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'revision_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'db',
        type: 'varchar(191)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'revision_id',
        references: 'reversion_revision(id)'
      }
    ],
    indexes: [
      {
        name: 'reversion_version_db_content_type_id_objec_b2c54f65_uniq',
        columns: ['db', 'content_type_id', 'object_id', 'revision_id'],
        type: 'UNIQUE'
      },
      {
        name: 'reversion_version_content_type_id_7d0ff25c_fk_django_co',
        columns: ['content_type_id'],
        type: 'BTREE'
      },
      {
        name: 'reversion_version_revision_id_af9f6a9d_fk_reversion_revision_id',
        columns: ['revision_id'],
        type: 'BTREE'
      },
      {
        name: 'reversion_v_content_f95daf_idx',
        columns: ['content_type_id', 'db'],
        type: 'BTREE'
      }
    ]
  },
  tracking_intermediatestatuswechsel: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime(6)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'status',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      }
    ],
    indexes: [
      {
        name: 'tracking_intermediatestatuswechsel_created_at_3b60e5b1',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'tracking_in_projekt_72b8a6_idx',
        columns: ['projekt_id', 'status'],
        type: 'BTREE'
      }
    ]
  },
  tracking_statuswechsel: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'status',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'duration',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'produkttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'projekt_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'status_first_achieved',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'produkttyp_id',
        references: 'produkt_produkttyp(id)'
      },
      {
        column: 'projekt_id',
        references: 'projekt_projekt(id)'
      }
    ],
    indexes: [
      {
        name: 'tracking_statuswechsel_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'tracking_statuswechsel_11c9e131',
        columns: ['mandant_id'],
        type: 'BTREE'
      },
      {
        name: 'tracking_statuswechsel_produkttyp_id_d21ead78',
        columns: ['produkttyp_id'],
        type: 'BTREE'
      },
      {
        name: 'tracking_statuswechsel_projekt_id_9fcfa2c9',
        columns: ['projekt_id'],
        type: 'BTREE'
      },
      {
        name: 'tracking_st_projekt_19790e_idx',
        columns: ['projekt_id', 'status'],
        type: 'BTREE'
      },
      {
        name: 'tracking_statuswechsel_status_first_achieved_3958ade5',
        columns: ['status_first_achieved'],
        type: 'BTREE'
      }
    ]
  },
  vertrieb_vertriebskanalmandant: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'created_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lastmodified_at',
        type: 'datetime',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'created_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'espeicherparameter_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'lastmodified_by_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'mandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'parameter_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'vertriebskanal_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'lead_import_vendor_id',
        type: 'varchar(100)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'kundenportal_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'espeicherparameter_id',
        references: 'energiespeicher_espeicherparameter(id)'
      },
      {
        column: 'vertriebskanal_id',
        references: 'vertrieb_vertriebskanal(id)'
      },
      {
        column: 'parameter_id',
        references: 'energiedach_edparameter(id)'
      },
      {
        column: 'mandant_id',
        references: 'mandant_mandant(id)'
      },
      {
        column: 'kundenportal_id',
        references: 'kundenportal_kundenportal(id)'
      }
    ],
    indexes: [
      {
        name: 'vertrieb_vertriebskanalmandante_mandant_id_1372f5b141bcb286_uniq',
        columns: ['mandant_id', 'vertriebskanal_id'],
        type: 'UNIQUE'
      },
      {
        name: 'lead_import_vendor_id',
        columns: ['lead_import_vendor_id'],
        type: 'UNIQUE'
      },
      {
        name: 'v_vertriebskanal_id_2a3e93b8345972_fk_vertrieb_vertriebskanal_id',
        columns: ['vertriebskanal_id'],
        type: 'BTREE'
      },
      {
        name: 'vertrieb_vertriebskanalmandanten_fde81f11',
        columns: ['created_at'],
        type: 'BTREE'
      },
      {
        name: 'vertrieb_vertriebskanalmandanten_89a8d048',
        columns: ['lastmodified_at'],
        type: 'BTREE'
      },
      {
        name: 'c546e488de326f7891a831984ce9252b',
        columns: ['espeicherparameter_id'],
        type: 'BTREE'
      },
      {
        name: 'vert_parameter_id_15b97401c0de8f6b_fk_energiedach_edparameter_id',
        columns: ['parameter_id'],
        type: 'BTREE'
      },
      {
        name: 'vertrieb_vertriebska_created_by_id_3d76de11_fk_account_e',
        columns: ['created_by_id'],
        type: 'BTREE'
      },
      {
        name: 'vertrieb_vertriebska_lastmodified_by_id_c2ac2708_fk_account_e',
        columns: ['lastmodified_by_id'],
        type: 'BTREE'
      },
      {
        name: 'vertrieb_vertriebska_kundenportal_id_19081841_fk_kundenpor',
        columns: ['kundenportal_id'],
        type: 'BTREE'
      }
    ]
  },
  vertrieb_vertriebskanalmandantdynamicparameter: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'parameter_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'produkttyp_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'vertriebskanalmandant_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'parameter_id',
        references: 'dynamic_dynamicparameter(id)'
      },
      {
        column: 'produkttyp_id',
        references: 'produkt_produkttyp(id)'
      },
      {
        column: 'vertriebskanalmandant_id',
        references: 'vertrieb_vertriebskanalmandant(id)'
      }
    ],
    indexes: [
      {
        name: 'vertrieb_vertriebska_parameter_id_1c437df7_fk_dynamic_d',
        columns: ['parameter_id'],
        type: 'BTREE'
      },
      {
        name: 'vertrieb_vertriebska_produkttyp_id_55ae7ef4_fk_produkt_p',
        columns: ['produkttyp_id'],
        type: 'BTREE'
      },
      {
        name: 'vertrieb_vertriebska_vertriebskanalmandan_12b9ea7d_fk_vertrieb_',
        columns: ['vertriebskanalmandant_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_blockkitrelation: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'quantity',
        type: 'smallint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'block_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'kit_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'deleted',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'block_id',
        references: 'vlink_buildingkit_buildingblock(id)'
      },
      {
        column: 'kit_id',
        references: 'vlink_buildingkit_buildingkit(id)'
      }
    ],
    indexes: [
      {
        name: 'unique_block_kit_relation',
        columns: ['kit_id', 'block_id'],
        type: 'UNIQUE'
      },
      {
        name: 'vlink_buildingkit_bl_block_id_114ab859_fk_vlink_bui',
        columns: ['block_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_booleanfieldvalue: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'value',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'block_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'field_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'frozen_version_id',
        type: 'bigint',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'block_id',
        references: 'vlink_buildingkit_buildingblock(id)'
      },
      {
        column: 'field_id',
        references: 'vlink_buildingkit_field(id)'
      },
      {
        column: 'frozen_version_id',
        references: 'vlink_buildingkit_frozenkitversion(id)'
      }
    ],
    indexes: [
      {
        name: 'Unique BooleanFieldValue',
        columns: ['field_id', 'block_id'],
        type: 'UNIQUE'
      },
      {
        name: 'vlink_buildingkit_bo_block_id_e9b5367a_fk_vlink_bui',
        columns: ['block_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_booleanfieldvalue_value_c2608815',
        columns: ['value'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_bo_frozen_version_id_2d809f2b_fk_vlink_bui',
        columns: ['frozen_version_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_buildingblock: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'internal_name',
        type: 'varchar(256)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'template_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'max_quantity',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'min_quantity',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'owner_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'trading_margin_absolute',
        type: 'decimal(8,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: '_external_name',
        type: 'varchar(256)',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'owner_related_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_price_hidden',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'trading_margin_relative',
        type: 'decimal(8,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_archived',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'description',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'frozen_version_id',
        type: 'bigint',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'frozen_version_id',
        references: 'vlink_buildingkit_frozenkitversion(id)'
      },
      {
        column: 'owner_id',
        references: 'vlink_buildingkit_accessor(id)'
      },
      {
        column: 'template_id',
        references: 'vlink_buildingkit_buildingblocktemplate(id)'
      }
    ],
    indexes: [
      {
        name: 'vlink_buildingkit_bu_template_id_429a1689_fk_vlink_bui',
        columns: ['template_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_bu_owner_id_6723b426_fk_vlink_bui',
        columns: ['owner_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_buildingblock__external_name_36543cbe',
        columns: ['_external_name'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_buildingblock_internal_name_cdb50e8c',
        columns: ['internal_name'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_bu_frozen_version_id_c1e9043c_fk_vlink_bui',
        columns: ['frozen_version_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_buildingblock_consumers: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'buildingblock_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'accessor_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'accessor_id',
        references: 'vlink_buildingkit_accessor(id)'
      },
      {
        column: 'buildingblock_id',
        references: 'vlink_buildingkit_buildingblock(id)'
      }
    ],
    indexes: [
      {
        name: 'vlink_buildingkit_buildi_buildingblock_id_accesso_6b9f27e4_uniq',
        columns: ['buildingblock_id', 'accessor_id'],
        type: 'UNIQUE'
      },
      {
        name: 'vlink_buildingkit_bu_accessor_id_ffdddcec_fk_vlink_bui',
        columns: ['accessor_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_buildingblocktemplate: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'name',
        type: 'varchar(128)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'slug',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'restrictable_quantity',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'position',
        type: 'smallint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_usable_for_multiple_blocks',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'is_price_hidden',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'frozen_version_id',
        type: 'bigint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_visible_in_overview',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'frozen_version_id',
        references: 'vlink_buildingkit_frozenkitversion(id)'
      }
    ],
    indexes: [
      {
        name: 'vlink_buildingkit_buildingblocktemplate_name_549e9aa0',
        columns: ['name'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_buildingblocktemplate_slug_ed26ab66',
        columns: ['slug'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_bu_frozen_version_id_1e21895b_fk_vlink_bui',
        columns: ['frozen_version_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_buildingkit: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'info_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'original_id',
        type: 'bigint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'owner_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'owner_related_id',
        type: 'int',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'is_archived',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'frozen_version_id',
        type: 'bigint',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'frozen_version_id',
        references: 'vlink_buildingkit_frozenkitversion(id)'
      },
      {
        column: 'info_id',
        references: 'vlink_buildingkit_buildingkitinfo(id)'
      },
      {
        column: 'original_id',
        references: 'vlink_buildingkit_buildingkit(id)'
      },
      {
        column: 'owner_id',
        references: 'vlink_buildingkit_accessor(id)'
      }
    ],
    indexes: [
      {
        name: 'unique_patched_kit_per_owner',
        columns: ['original_id', 'owner_id'],
        type: 'UNIQUE'
      },
      {
        name: 'vlink_buildingkit_bu_original_id_4ceaafb1_fk_vlink_bui',
        columns: ['original_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_bu_info_id_acb36daf_fk_vlink_bui',
        columns: ['info_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_bu_owner_id_2839f597_fk_vlink_bui',
        columns: ['owner_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_bu_frozen_version_id_d94c5fba_fk_vlink_bui',
        columns: ['frozen_version_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_buildingkitinfo: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'name',
        type: 'varchar(256)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'description',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      },
      {
        name: 'category_id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'uuid',
        type: 'char(32)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'frozen_version_id',
        type: 'bigint',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'category_id',
        references: 'produkt_produkt(id)'
      },
      {
        column: 'frozen_version_id',
        references: 'vlink_buildingkit_frozenkitversion(id)'
      }
    ],
    indexes: [
      {
        name: 'vlink_buildingkit_bu_category_id_f59a93e0_fk_produkt_p',
        columns: ['category_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_bu_frozen_version_id_738e860c_fk_vlink_bui',
        columns: ['frozen_version_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_buildingkitinfo_consumers: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'buildingkitinfo_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'accessor_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'accessor_id',
        references: 'vlink_buildingkit_accessor(id)'
      },
      {
        column: 'buildingkitinfo_id',
        references: 'vlink_buildingkit_buildingkitinfo(id)'
      }
    ],
    indexes: [
      {
        name: 'vlink_buildingkit_buildi_buildingkitinfo_id_acces_616a5f44_uniq',
        columns: ['buildingkitinfo_id', 'accessor_id'],
        type: 'UNIQUE'
      },
      {
        name: 'vlink_buildingkit_bu_accessor_id_c8e8e3a0_fk_vlink_bui',
        columns: ['accessor_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_choicefieldvalue: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'block_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'field_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'value_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'frozen_version_id',
        type: 'bigint',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'block_id',
        references: 'vlink_buildingkit_buildingblock(id)'
      },
      {
        column: 'field_id',
        references: 'vlink_buildingkit_field(id)'
      },
      {
        column: 'frozen_version_id',
        references: 'vlink_buildingkit_frozenkitversion(id)'
      },
      {
        column: 'value_id',
        references: 'vlink_buildingkit_fieldchoice(id)'
      }
    ],
    indexes: [
      {
        name: 'vlink_buildingkit_ch_block_id_85150de1_fk_vlink_bui',
        columns: ['block_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_ch_field_id_235c2d5b_fk_vlink_bui',
        columns: ['field_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_ch_value_id_d551c640_fk_vlink_bui',
        columns: ['value_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_ch_frozen_version_id_82e4823e_fk_vlink_bui',
        columns: ['frozen_version_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_decimalfieldvalue: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'value',
        type: 'decimal(10,4)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'block_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'field_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'frozen_version_id',
        type: 'bigint',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'block_id',
        references: 'vlink_buildingkit_buildingblock(id)'
      },
      {
        column: 'field_id',
        references: 'vlink_buildingkit_field(id)'
      },
      {
        column: 'frozen_version_id',
        references: 'vlink_buildingkit_frozenkitversion(id)'
      }
    ],
    indexes: [
      {
        name: 'Unique DecimalFieldValue',
        columns: ['field_id', 'block_id'],
        type: 'UNIQUE'
      },
      {
        name: 'vlink_buildingkit_de_block_id_8cc978d2_fk_vlink_bui',
        columns: ['block_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_decimalfieldvalue_value_05442d1a',
        columns: ['value'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_de_frozen_version_id_a3c58959_fk_vlink_bui',
        columns: ['frozen_version_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_extracost: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'name',
        type: 'varchar(128)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'price',
        type: 'decimal(8,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'hardware_share',
        type: 'decimal(5,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'building_kit_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'description',
        type: 'longtext',
        nullable: true,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'building_kit_id',
        references: 'vlink_buildingkit_buildingkit(id)'
      }
    ],
    indexes: [
      {
        name: 'vlink_buildingkit_ex_building_kit_id_36bb4dd6_fk_vlink_bui',
        columns: ['building_kit_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_field_frozen_versions: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'field_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'frozenkitversion_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'field_id',
        references: 'vlink_buildingkit_field(id)'
      },
      {
        column: 'frozenkitversion_id',
        references: 'vlink_buildingkit_frozenkitversion(id)'
      }
    ],
    indexes: [
      {
        name: 'vlink_buildingkit_field__field_id_frozenkitversio_34ff1deb_uniq',
        columns: ['field_id', 'frozenkitversion_id'],
        type: 'UNIQUE'
      },
      {
        name: 'vlink_buildingkit_fi_frozenkitversion_id_06be6583_fk_vlink_bui',
        columns: ['frozenkitversion_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_fieldchoice_frozen_versions: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'fieldchoice_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'frozenkitversion_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'fieldchoice_id',
        references: 'vlink_buildingkit_fieldchoice(id)'
      },
      {
        column: 'frozenkitversion_id',
        references: 'vlink_buildingkit_frozenkitversion(id)'
      }
    ],
    indexes: [
      {
        name: 'vlink_buildingkit_fieldc_fieldchoice_id_frozenkit_6f2e065b_uniq',
        columns: ['fieldchoice_id', 'frozenkitversion_id'],
        type: 'UNIQUE'
      },
      {
        name: 'vlink_buildingkit_fi_frozenkitversion_id_92221702_fk_vlink_bui',
        columns: ['frozenkitversion_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_frozenkitversion: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'trading_margin_value',
        type: 'decimal(6,2)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'source_kit_id',
        type: 'bigint',
        nullable: true,
        default: 'NULL',
        constraints: []
      },
      {
        name: 'individual_block_margins',
        type: 'json',
        nullable: false,
        default: "(_utf8mb4'{}')",
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'source_kit_id',
        references: 'vlink_buildingkit_buildingkit(id)'
      }
    ],
    indexes: [
      {
        name: 'vlink_buildingkit_fr_source_kit_id_aaeacc8a_fk_vlink_bui',
        columns: ['source_kit_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_frozenkitversion_individualized_relations: {
    columns: [
      {
        name: 'id',
        type: 'int',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'frozenkitversion_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'blockkitrelation_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'blockkitrelation_id',
        references: 'vlink_buildingkit_blockkitrelation(id)'
      },
      {
        column: 'frozenkitversion_id',
        references: 'vlink_buildingkit_frozenkitversion(id)'
      }
    ],
    indexes: [
      {
        name: 'vlink_buildingkit_frozen_frozenkitversion_id_bloc_6592d630_uniq',
        columns: ['frozenkitversion_id', 'blockkitrelation_id'],
        type: 'UNIQUE'
      },
      {
        name: 'vlink_buildingkit_fr_blockkitrelation_id_8cf020fd_fk_vlink_bui',
        columns: ['blockkitrelation_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_integerfieldvalue: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'value',
        type: 'int',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'block_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'field_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'frozen_version_id',
        type: 'bigint',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'block_id',
        references: 'vlink_buildingkit_buildingblock(id)'
      },
      {
        column: 'field_id',
        references: 'vlink_buildingkit_field(id)'
      },
      {
        column: 'frozen_version_id',
        references: 'vlink_buildingkit_frozenkitversion(id)'
      }
    ],
    indexes: [
      {
        name: 'unique_integer_field_value',
        columns: ['field_id', 'block_id'],
        type: 'UNIQUE'
      },
      {
        name: 'vlink_buildingkit_in_block_id_0731f1ac_fk_vlink_bui',
        columns: ['block_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_integerfieldvalue_value_d5405fed',
        columns: ['value'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_in_frozen_version_id_394ed82d_fk_vlink_bui',
        columns: ['frozen_version_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_templatefieldrelation: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'required',
        type: 'tinyint(1)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'field_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'template_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'field_slug',
        type: 'varchar(100)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'frozen_version_id',
        type: 'bigint',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'field_id',
        references: 'vlink_buildingkit_field(id)'
      },
      {
        column: 'frozen_version_id',
        references: 'vlink_buildingkit_frozenkitversion(id)'
      },
      {
        column: 'template_id',
        references: 'vlink_buildingkit_buildingblocktemplate(id)'
      }
    ],
    indexes: [
      {
        name: 'unique_template_field',
        columns: ['template_id', 'field_id'],
        type: 'UNIQUE'
      },
      {
        name: 'vlink_buildingkit_te_field_id_34a12070_fk_vlink_bui',
        columns: ['field_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_templatefieldrelation_field_slug_7850d0ef',
        columns: ['field_slug'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_te_frozen_version_id_6cb453e6_fk_vlink_bui',
        columns: ['frozen_version_id'],
        type: 'BTREE'
      }
    ]
  },
  vlink_buildingkit_textfieldvalue: {
    columns: [
      {
        name: 'id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: ['AUTO_INCREMENT']
      },
      {
        name: 'value',
        type: 'varchar(1000)',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'block_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'field_id',
        type: 'bigint',
        nullable: false,
        default: null,
        constraints: []
      },
      {
        name: 'frozen_version_id',
        type: 'bigint',
        nullable: true,
        default: 'NULL',
        constraints: []
      }
    ],
    primaryKeys: ['id'],
    foreignKeys: [
      {
        column: 'block_id',
        references: 'vlink_buildingkit_buildingblock(id)'
      },
      {
        column: 'field_id',
        references: 'vlink_buildingkit_field(id)'
      },
      {
        column: 'frozen_version_id',
        references: 'vlink_buildingkit_frozenkitversion(id)'
      }
    ],
    indexes: [
      {
        name: 'unique_text_field_value',
        columns: ['field_id', 'block_id'],
        type: 'UNIQUE'
      },
      {
        name: 'vlink_buildingkit_te_block_id_67b31b1f_fk_vlink_bui',
        columns: ['block_id'],
        type: 'BTREE'
      },
      {
        name: 'vlink_buildingkit_te_frozen_version_id_288d49d6_fk_vlink_bui',
        columns: ['frozen_version_id'],
        type: 'BTREE'
      }
    ]
  }
}
